import React from 'react';
import Router from 'next/router';
import Head from 'next/head';
import Image from 'next/image';
import dynamic from 'next/dynamic';
import scrollTo from '../../components/functions/scrollTo';
import Platform from './PlatformSmm';
import LazyLoad, { lazyload, forceCheck } from 'react-lazyload';
import CustomProposalWithoutPlatform from '../../components/smm/CustomProposalWithoutPlatform';
import SchedulaACall from '../../components/Base/SchedulaACall';
const ViewMore = dynamic(() => import('../../components/ViewMore'));
const Engagement = dynamic(() => import('../../components/Engagement'));
const ProcessSlider = dynamic(() => import('../../components/sliders/SMMProcessSlider'));
const CertificatesSlider = dynamic(() => import('../../components/sliders/CertificatesSlider'));
// const Calculator = dynamic(() => import('../../components/SMMCalculator'))
const Work = dynamic(() => import('../../components/Work'));
const CustomProposal = dynamic(() => import('../../components/CustomProposal'));
const SocialMediaProposal = dynamic(() => import('./SocialMediaProposal'));
const SMMPricing = dynamic(() => import('../../components/smm/SMMPriceing'));
const SMMCustomProposal = dynamic(() => import('../../components/smm/CustomProposal'));
const Offer = dynamic(() => import('../../components/Offer'));
const FacebookContent = dynamic(() => import('./parts/fb'));
const InstagramContent = dynamic(() => import('./parts/insta'));
const LinkedinContent = dynamic(() => import('./parts/linkedin'));
const SnapchatContent = dynamic(() => import('./parts/snapchat'));
const XContent = dynamic(() => import('./parts/x'));
const Faq = dynamic(() => import('../../components/Faq'));
lazyload({
  width: '100%',
});
class SocialMediaMarketing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currency: props.currency,
      loadedOfferModal: false,
      showOfferModal: false,
      offerModalTitle: '',
      loadedOfferModal2: false,
      showOfferModal2: false,
      loadedSmmGetPricingModal: false,
      showSMMPricingModal: false,
      loadedCustomProposalModal: false,
      showSMMCustomProposalModal: false,
      loadedCustomProposalWithoutPlatformModal: false,
      showSMMCustomProposalWithoutPlatformModal: false,
      facebook: React.createRef(),
      instagram: React.createRef(),
      linkedin: React.createRef(),
      x: React.createRef(),
      snapchat: React.createRef(),
      step: 1,
      platform: null,
      activePlan: 1,
      showFb: false,
      showInta: false,
      showX: false,
      showLinkedIn: false,
      showSnapchat: false,
      packages: [],
      platforms: [],
      platformsForPlans: [],
    };
    this.showOfferModal = this.showOfferModal.bind(this);
    this.hideOfferModal = this.hideOfferModal.bind(this);
    this.showOfferModal2 = this.showOfferModal2.bind(this);
    this.hideOfferModal2 = this.hideOfferModal2.bind(this);
    this.scrollToPlatform = this.scrollToPlatform.bind(this);
    this.hideSMMPricingModal = this.hideSMMPricingModal.bind(this);
    this.hideSMMCustomProposalModal = this.hideSMMCustomProposalModal.bind(this);
    this.hideSMMCustomProposalWithoutPlatformModal = this.hideSMMCustomProposalWithoutPlatformModal.bind(this);

    this.fbRef = React.createRef();
    this.instaRef = React.createRef();
    this.linkedInRef = React.createRef();
    this.snapchatRef = React.createRef();
    this.xRef = React.createRef();
  }
  hideSMMPricingModal() {
    this.setState({ showSMMPricingModal: false, loadedSmmGetPricingModal: false });
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    document.documentElement.style.overflow = 'auto';
  }
  hideSMMCustomProposalModal() {
    this.setState({ showSMMCustomProposalModal: false, loadedCustomProposalModal: false });
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    document.documentElement.style.overflow = 'auto';
  }
  hideSMMCustomProposalWithoutPlatformModal() {
    this.setState({ showSMMCustomProposalWithoutPlatformModal: false, loadedCustomProposalWithoutPlatformModal: false });
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    document.documentElement.style.overflow = 'auto';
  }
  showOfferModal(service) {
    if (window.innerWidth > 768) {
      document.getElementById('offer-form').reset();
      this.setState({ showOfferModal: true, offerModalTitle: service });
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    } else {
      Router.push('/quote/smm');
    }
  }
  hideOfferModal() {
    this.setState({ showOfferModal: false, loadedOfferModal: false });
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    document.documentElement.style.overflow = 'auto';
  }
  showOfferModal2() {
    document.getElementById('offer-form').reset();
    this.setState({ showOfferModal2: true });
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
  }
  showSMMPricing = () => {
    if (this.props.width < 768) {
      window.location.href = '/social-media-marketing/proposals/smm-pricing';
    } else {
      document.getElementById('offer-form-smm').reset();
      this.setState({ showSMMPricingModal: true, step: 1 });
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    }
  };
  showSMMCustomProposal = () => {
    if (this.props.width < 768) {
      window.location.href = '/social-media-marketing/proposals/smm-custom-proposal';
    } else {
      this.setState({ showSMMCustomProposalModal: true, step: 1 });
      document.getElementById('offer-form-smm-custom').reset();
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    }
  };
  showSMMCustomProposalWithoutPlatform = platform => {
    if (this.props.width < 768) {
      window.location.href = '/social-media-marketing/proposals/custom-proposal?p=' + platform;
    } else {
      this.setState({ showSMMCustomProposalWithoutPlatformModal: true, step: 1, platform });
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    }
  };
  hideOfferModal2() {
    this.setState({ showOfferModal2: false, loadedOfferModal2: false });
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    document.documentElement.style.overflow = 'auto';
  }
  stickyBar() {
    var bar = document.getElementById('bar');
    var bar_offset = bar.offsetTop;
    window.addEventListener(
      'scroll',
      function () {
        if (window.pageYOffset > bar_offset + 91) {
          bar.classList.add('sticky');
        } else {
          bar.classList.remove('sticky');
        }
      },
      false
    );
  }
  scrollToPlatform(platform_id, offset, close = false) {
    if (!close) this.state[platform_id].current.show();
    scrollTo(platform_id, offset);
    this.changeUrl(platform_id);
  }
  changeUrl(platform) {
    const url = window.location.origin + window.location.pathname + '#' + platform;
    window.history.pushState({}, '', url);
  }
  componentDidMount() {
    forceCheck();
    this.stickyBar();

    // window.addEventListener('scroll',this.scrollHash,true)
  }
  // componentWillUnmount() {
  //     window.removeEventListener('scroll', this.scrollHash, true);
  // }

  scrollHash = () => {
    let facebook = document.getElementById('facebook');
    let instagram = document.getElementById('instagram');
    let linkedin = document.getElementById('linkedin');
    let snapchat = document.getElementById('snapchat');
    let x = document.getElementById('x');

    if (facebook?.offsetTop <= window.pageYOffset) {
      const url = window.location.origin + window.location.pathname + '#' + 'facebook';
      window.history.pushState({}, '', url);
    }
    if (instagram?.offsetTop <= window.pageYOffset) {
      const url = window.location.origin + window.location.pathname + '#' + 'instagram';
      window.history.pushState({}, '', url);
    }
    if (linkedin?.offsetTop <= window.pageYOffset) {
      const url = window.location.origin + window.location.pathname + '#' + 'linkedin';
      window.history.pushState({}, '', url);
    }
    if (snapchat?.offsetTop <= window.pageYOffset) {
      const url = window.location.origin + window.location.pathname + '#' + 'snapchat';
      window.history.pushState({}, '', url);
    }
    if (x?.offsetTop <= window.pageYOffset) {
      const url = window.location.origin + window.location.pathname + '#' + 'x';
      window.history.pushState({}, '', url);
    }
  };
  scrollTo = ref => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };
  hideAll = () => {
    this.setState({
      showFb: false,
      showInta: false,
      showX: false,
      showLinkedIn: false,
      showSnapchat: false,
    });
  };
  render() {
    return (
      <div>
        <Head>
          <title>Social Media Marketing Services | Prodigi</title>
          <link rel="alternate" hrefLang="en" href="https://weprodigi.com/social-media-marketing" />
          <meta
            name="description"
            content="Strengthen your online presence with Prodigi's social media marketing services. Engage your audience with strategic content across platforms."
          />
          <meta property="og:url" content="https://weprodigi.com/social-media-marketing" />
          <meta property="og:type" content="article" />
          <meta property="og:title" content="Social Media Marketing Services | Prodigi" />
          <meta
            property="og:description"
            content="Strengthen your online presence with Prodigi's social media marketing services. Engage your audience with strategic content across platforms."
          />
        </Head>
        <div className="relative w-full overflow-hidden intro h-intro-info lg:h-intro-md bg-gray-light bg-grid">
          <div className="relative h-full md:flex md:items-center pt-12p pb-15 md:py-12p">
            <div className="container h-full md:h-auto">
              <div className="relative z-10 flex flex-col flex-wrap items-start h-full md:h-auto justify-top md:justify-center h-3/6 md:pb-90 md:mb-120 lg:mb-0 lg:pb-90">
                <h1 className="font-black leading-none text-black uppercase md:text-purple text-10vw md:text-6xl 2xl:text-72">
                  Social Media
                  <span className="block text-purple">marketing</span>
                  <span className="block text-purple md:text-black">services</span>
                </h1>

                <div className={'flex'}>
                  <a
                    onClick={() => this.showSMMPricing(null)}
                    className="relative z-10 hidden py-5 overflow-hidden transition-all border-2 cursor-pointer get-smm-proposal-button md:inline-block rounded-5 border-purple text-18 text-purple px-23 mt-23 icon-paper-container transition-400"
                  >
                    <span className="icon icon-pricing" />
                    <span className="block text">Get Pricing</span>
                  </a>
                  <a
                    onClick={() => this.showSMMCustomProposal(null)}
                    className="relative z-10 hidden py-5 ml-20 overflow-hidden transition-all border-2 cursor-pointer get-smm-proposal-button md:inline-block rounded-5 border-purple text-18 text-purple px-23 mt-23 icon-paper-container transition-400"
                  >
                    <span className="icon icon-paper icon-paper2" />
                    <span className="block text">Get Custom Proposal</span>
                  </a>
                </div>
              </div>
            </div>
            <div className="absolute bottom-0 left-0 top-auto w-full h-full">
              <div className="personage-container">
                <div className="absolute bottom-0 left-0 right-0 z-10 w-4/6 h-auto mx-auto personage md:w-4/5 lg:w-full md:left-auto">
                  <picture>
                    <source media="(min-width:768px)" srcSet="/images/personages/smm/index.webp" type="image/webp" />
                    <source media="(min-width:768px)" srcSet="/images/personages/smm/index.png" type="image/png" />
                    <source
                      media="(max-width:768px)"
                      srcSet="data:image/webp;base64,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"
                      alt={'select'}
                    />
                    <source media="(max-width:768px)" srcSet="/images/personages/smm/index.png" type="image/png" />
                    <img width="731" height="731" src="" alt={'personage'} />
                  </picture>
                  <div className="ball ball-1" />
                  <div className="ball ball-2" />
                  <div className="ball ball-3" />
                  <div className="ball ball-4" />
                  <div className="ball ball-5" />
                  <div className="ball ball-6" />
                  <div className="glitch-container">
                    <div className="img">
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                      <div className="glitch-line" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="absolute bottom-0 left-0 z-10 hidden ruller md:block" />
              <div className="absolute top-0 left-auto hidden ruller ruller2 md:block" />
              <div className="absolute bottom-0 right-0 top-auto left-auto w-full overlay md:w-1/2 h-3/6 md:h-full bg-purple">
                <style global jsx>{`
                  // .h-intro{
                  //   height: calc(1vh * 100 - 85px);
                  // }
                  @media (min-width: 769px) {
                    .personage-container {
                      position: absolute;
                      right: 0%;
                      bottom: 0;
                      width: calc(43vw - 100px);
                      height: calc((43vw - 100px) * 1.2403);
                      max-width: 570px;
                      max-height: 707px;
                      z-index: 1;
                    }
                    .overlay {
                      width: calc((100% - 1140px) / 2 + 220px);
                    }
                  }
                  .ruller {
                    width: 17px;
                    height: 433px;
                    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAGxCAMAAACz2K2SAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAACBUExURUdwTAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADqG7ZIAAAArdFJOUwAPGCAoEyRQPApaB2RgKkhsfh6MQHZUNThLFi8yb4gbAmhEqJCAmLUVwEYnwbvZAAADMElEQVRYw82Za3eiMBCGQQG1uGqpV7DVXtxl+/9/4KqQyZC3A2OWevp8zDlJyGRmMu8QvLsEGsbEZlCNjIh5Fqh5JJ731UhsSaVZCTEMq5EHYj3U7z4lHqJqJCKSiTQrbnD5yCfOKlHuPieWh2pkQ+xz/Sns1o9b/Sx7X7vIXec01q+zIKaF/gYHLsGHy42nMF5nPXM78PHD1V4/q68oWBELryg4k4WNKDizOyh3t1NGCcTXxMcPTzf44TMx3UsjfplEQ+TCdq8JQhdVFBTErJ5wZFQjbM0UMlJ9FxPLUTrFkhjXfvhGmNySWsR1ToSJggMxED1hxrmmzTlnHDdPeubrD1gTu8RdOQql3e2qxj6/CGPDjDhM9HmMjcyqkdKSekVTqLLhBXaKGnaKGpUN0TdaX7TaPjvirfafIZGJNtwTRSzlQ/RnO2A8szWrl9LuQ871onecZem+3YIfbgnzCqNV2160Em2YQU6IFbFcW/438bKUZmF049vEbJjr8+GrS9POF9ptWEq1FsJ8I5VqJJYT4u67yCfuC/ta6G1os6i5C1Y1ZYpT1E4+5awzyIdphz+brMUyUqQ/hU0h6+R/6sw/xPtaP8vuVeTSnXbZ8Ezw4hLkLq3+nMTSC/vza6T+q9wzC+3x+7IhVrkatWUrEBPLNh9+LO9vw78ud1UKfmoLb5Ddxey79XJfftiXDf30MstjB7davmUdPxtirsN8iDnz+3oOfmoL3wKs1TU6BaNAU53im9t8lwfuuyN8AHqdn9piMVhIdUtrfZhJeRVrUY0fYs3WUWNfaz+sD7GGbI3lXBphNvR7l0W1hXU41uqau0BdgNpB0z9s6JRx+aWW8cuHfmoLdZxGJbEe2kYflahPNWoLtTDqZdTUt3WSR4lep6Bq+yTkKhf7EiwfRpC1jt3dgyQEG2a6fHj8sm+DvZ22Cs30iLCP5Ke2buxdpG59+PQJ3eZU6sWxnFDq1Rb2BrF/qMmHfXWkMZbvWSP19V8G+9jNXnfa4QlGUPtVuX0pBT+93FeVi/9T8J+LxoaaKNBUF3429NPLfj2Htt3Nfz18u39azwH1sp8f9hUF8H/5H3SpyfO7BSgcAAAAAElFTkSuQmCC);
                    background-repeat: no-repeat;
                    background-size: contain;
                  }
                  .ruller2 {
                    right: calc((100% - 1140px) / 2 + 220px);
                    transform: scale(-1);
                  }
                  .personage-container .glasses {
                    position: absolute;
                    width: 33.65252999663475%;
                    height: 9.8495211934%;
                    left: 1.3%;
                    right: 0;
                    bottom: 54.415550114%;
                    margin: 0 auto;
                    background-image: url(data:image/png;base64,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);
                    background-repeat: no-repeat;
                    background-size: contain;
                    z-index: 3;
                  }
                  .personage-container .ball {
                    position: absolute;
                    width: 6.668%;
                    padding-bottom: 6.668%;
                    border-radius: 50%;
                    background-size: cover;
                  }
                  .personage-container .ball.ball-1 {
                    top: 35%;
                    left: 19%;
                    background-image: url(/images/animation-parts/smm/ball1.png);
                    animation: ball1 7s infinite linear forwards alternate;
                  }
                  .personage-container .ball.ball-2 {
                    top: 30.5%;
                    left: 27%;
                    background-image: url(/images/animation-parts/smm/ball2.png);
                    animation: ball2 6.8s 1.6s infinite linear forwards alternate;
                  }
                  .personage-container .ball.ball-3 {
                    top: 39%;
                    left: 27%;
                    background-image: url(/images/animation-parts/smm/ball3.png);
                    animation: ball3 7.1s 1.3s infinite linear forwards alternate;
                  }
                  .personage-container .ball.ball-4 {
                    top: 34.7%;
                    left: 68.3%;
                    background-image: url(/images/animation-parts/smm/ball4.png);
                    animation: ball4 6s 0.3s infinite linear forwards alternate;
                  }
                  .personage-container .ball.ball-5 {
                    top: 42%;
                    left: 67%;
                    background-image: url(/images/animation-parts/smm/ball5.png);
                    animation: ball5 5.6s 0s infinite linear forwards alternate;
                  }
                  .personage-container .ball.ball-6 {
                    top: 39.5%;
                    left: 76%;
                    background-image: url(/images/animation-parts/smm/ball6.png);
                    animation-delay: 1.5s;
                    animation: ball6 5s 0.2s infinite linear forwards alternate;
                  }
                  @keyframes ball1 {
                    0% {
                      transform: translate(0, 0);
                    }
                    33% {
                      transform: translate(-9px, -2px);
                    }
                    66% {
                      transform: translate(6px, -5px);
                    }
                    100% {
                      transform: translate(-7px, -5px);
                    }
                  }
                  @keyframes ball2 {
                    0% {
                      transform: translate(0, 0);
                    }
                    33% {
                      transform: translate(-7px, -5px);
                    }
                    66% {
                      transform: translate(6px, -5px);
                    }
                    100% {
                      transform: translate(-9px, -2px);
                    }
                  }
                  @keyframes ball3 {
                    0% {
                      transform: translate(0, 0);
                    }
                    33% {
                      transform: translate(-7px, -5px);
                    }
                    66% {
                      transform: translate(6px, -5px);
                    }
                    100% {
                      transform: translate(-9px, -2px);
                    }
                  }
                  @keyframes ball4 {
                    0% {
                      transform: translate(0, 0);
                    }
                    33% {
                      transform: translate(8px, 6px);
                    }
                    66% {
                      transform: translate(-7px, -4px);
                    }
                    100% {
                      transform: translate(10px, -8px);
                    }
                  }
                  @keyframes ball5 {
                    0% {
                      transform: translate(0, 0);
                    }
                    20% {
                      transform: translate(-7px, -5px);
                    }
                    69% {
                      transform: translate(6px, -5px);
                    }
                    100% {
                      transform: translate(-9px, -2px);
                    }
                  }
                  @keyframes ball6 {
                    0% {
                      transform: translate(0, 0);
                    }
                    20% {
                      transform: translate(-7px, -5px);
                    }
                    69% {
                      transform: translate(6px, -5px);
                    }
                    100% {
                      transform: translate(-9px, -2px);
                    }
                  }
                  .glitch-container {
                    position: absolute;
                    bottom: 62.2%;
                    right: 31%;
                    z-index: 10;
                    width: 36.8421%;
                    height: 0;
                    padding-bottom: 7.546%;
                    transform: rotate(4deg);
                  }
                  .glitch-container .img {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    overflow: hidden;
                  }
                  .glitch-line:nth-child(0) {
                    position: absolute;
                    height: 2.3255%;
                    top: -2.3255%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 -2.3255813953%;
                    background-size: cover;
                    animation: smm-glitch0 0.6s 0s linear infinite;
                  }
                  @keyframes smm-glitch0 {
                    0% {
                      background-position: 0 -2.3255813953%;
                    }
                    20% {
                      background-position: 30px -2.3255813953%;
                    }
                    22% {
                      background-position: -10px -2.3255813953%;
                    }
                    28.8% {
                      background-position: 15px -2.3255813953%;
                    }
                    37.6% {
                      background-position: -17px -2.3255813953%;
                    }
                    40% {
                      background-position: -22px -2.3255813953%;
                    }
                    56% {
                      background-position: 150px -2.3255813953%;
                    }
                    57.6% {
                      background-position: 26px -2.3255813953%;
                    }
                    68% {
                      background-position: 28px -2.3255813953%;
                    }
                    68.8% {
                      background-position: 0 -2.3255813953%;
                    }
                    71.2% {
                      background-position: -5px -2.3255813953%;
                    }
                    73.6% {
                      background-position: -4px -2.3255813953%;
                    }
                    83.2% {
                      background-position: -105px -2.3255813953%;
                    }
                    100% {
                      background-position: 0 -2.3255813953%;
                    }
                  }
                  .glitch-line:nth-child(1) {
                    position: absolute;
                    height: 2.3255%;
                    top: 0%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 0%;
                    background-size: cover;
                    animation: smm-glitch1 0.6s -0.0139534884s linear infinite;
                  }
                  @keyframes smm-glitch1 {
                    0% {
                      background-position: 0 0%;
                    }
                    20% {
                      background-position: 30px 0%;
                    }
                    22% {
                      background-position: -10px 0%;
                    }
                    28.8% {
                      background-position: 15px 0%;
                    }
                    37.6% {
                      background-position: -17px 0%;
                    }
                    40% {
                      background-position: -22px 0%;
                    }
                    56% {
                      background-position: 150px 0%;
                    }
                    57.6% {
                      background-position: 26px 0%;
                    }
                    68% {
                      background-position: 28px 0%;
                    }
                    68.8% {
                      background-position: 0 0%;
                    }
                    71.2% {
                      background-position: -5px 0%;
                    }
                    73.6% {
                      background-position: -4px 0%;
                    }
                    83.2% {
                      background-position: -105px 0%;
                    }
                    100% {
                      background-position: 0 0%;
                    }
                  }
                  .glitch-line:nth-child(2) {
                    position: absolute;
                    height: 2.3255%;
                    top: 2.3255%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 2.3255813953%;
                    background-size: cover;
                    animation: smm-glitch2 0.6s -0.0279069767s linear infinite;
                  }
                  @keyframes smm-glitch2 {
                    0% {
                      background-position: 0 2.3255813953%;
                    }
                    20% {
                      background-position: 30px 2.3255813953%;
                    }
                    22% {
                      background-position: -10px 2.3255813953%;
                    }
                    28.8% {
                      background-position: 15px 2.3255813953%;
                    }
                    37.6% {
                      background-position: -17px 2.3255813953%;
                    }
                    40% {
                      background-position: -22px 2.3255813953%;
                    }
                    56% {
                      background-position: 150px 2.3255813953%;
                    }
                    57.6% {
                      background-position: 26px 2.3255813953%;
                    }
                    68% {
                      background-position: 28px 2.3255813953%;
                    }
                    68.8% {
                      background-position: 0 2.3255813953%;
                    }
                    71.2% {
                      background-position: -5px 2.3255813953%;
                    }
                    73.6% {
                      background-position: -4px 2.3255813953%;
                    }
                    83.2% {
                      background-position: -105px 2.3255813953%;
                    }
                    100% {
                      background-position: 0 2.3255813953%;
                    }
                  }
                  .glitch-line:nth-child(3) {
                    position: absolute;
                    height: 2.3255%;
                    top: 4.651%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 4.6511627907%;
                    background-size: cover;
                    animation: smm-glitch3 0.6s -0.0418604651s linear infinite;
                  }
                  @keyframes smm-glitch3 {
                    0% {
                      background-position: 0 4.6511627907%;
                    }
                    20% {
                      background-position: 30px 4.6511627907%;
                    }
                    22% {
                      background-position: -10px 4.6511627907%;
                    }
                    28.8% {
                      background-position: 15px 4.6511627907%;
                    }
                    37.6% {
                      background-position: -17px 4.6511627907%;
                    }
                    40% {
                      background-position: -22px 4.6511627907%;
                    }
                    56% {
                      background-position: 150px 4.6511627907%;
                    }
                    57.6% {
                      background-position: 26px 4.6511627907%;
                    }
                    68% {
                      background-position: 28px 4.6511627907%;
                    }
                    68.8% {
                      background-position: 0 4.6511627907%;
                    }
                    71.2% {
                      background-position: -5px 4.6511627907%;
                    }
                    73.6% {
                      background-position: -4px 4.6511627907%;
                    }
                    83.2% {
                      background-position: -105px 4.6511627907%;
                    }
                    100% {
                      background-position: 0 4.6511627907%;
                    }
                  }
                  .glitch-line:nth-child(4) {
                    position: absolute;
                    height: 2.3255%;
                    top: 6.9765%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 6.976744186%;
                    background-size: cover;
                    animation: smm-glitch4 0.6s -0.0558139535s linear infinite;
                  }
                  @keyframes smm-glitch4 {
                    0% {
                      background-position: 0 6.976744186%;
                    }
                    20% {
                      background-position: 30px 6.976744186%;
                    }
                    22% {
                      background-position: -10px 6.976744186%;
                    }
                    28.8% {
                      background-position: 15px 6.976744186%;
                    }
                    37.6% {
                      background-position: -17px 6.976744186%;
                    }
                    40% {
                      background-position: -22px 6.976744186%;
                    }
                    56% {
                      background-position: 150px 6.976744186%;
                    }
                    57.6% {
                      background-position: 26px 6.976744186%;
                    }
                    68% {
                      background-position: 28px 6.976744186%;
                    }
                    68.8% {
                      background-position: 0 6.976744186%;
                    }
                    71.2% {
                      background-position: -5px 6.976744186%;
                    }
                    73.6% {
                      background-position: -4px 6.976744186%;
                    }
                    83.2% {
                      background-position: -105px 6.976744186%;
                    }
                    100% {
                      background-position: 0 6.976744186%;
                    }
                  }
                  .glitch-line:nth-child(5) {
                    position: absolute;
                    height: 2.3255%;
                    top: 9.302%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 9.3023255814%;
                    background-size: cover;
                    animation: smm-glitch5 0.6s -0.0697674419s linear infinite;
                  }
                  @keyframes smm-glitch5 {
                    0% {
                      background-position: 0 9.3023255814%;
                    }
                    20% {
                      background-position: 30px 9.3023255814%;
                    }
                    22% {
                      background-position: -10px 9.3023255814%;
                    }
                    28.8% {
                      background-position: 15px 9.3023255814%;
                    }
                    37.6% {
                      background-position: -17px 9.3023255814%;
                    }
                    40% {
                      background-position: -22px 9.3023255814%;
                    }
                    56% {
                      background-position: 150px 9.3023255814%;
                    }
                    57.6% {
                      background-position: 26px 9.3023255814%;
                    }
                    68% {
                      background-position: 28px 9.3023255814%;
                    }
                    68.8% {
                      background-position: 0 9.3023255814%;
                    }
                    71.2% {
                      background-position: -5px 9.3023255814%;
                    }
                    73.6% {
                      background-position: -4px 9.3023255814%;
                    }
                    83.2% {
                      background-position: -105px 9.3023255814%;
                    }
                    100% {
                      background-position: 0 9.3023255814%;
                    }
                  }
                  .glitch-line:nth-child(6) {
                    position: absolute;
                    height: 2.3255%;
                    top: 11.6275%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 11.6279069767%;
                    background-size: cover;
                    animation: smm-glitch6 0.6s -0.0837209302s linear infinite;
                  }
                  @keyframes smm-glitch6 {
                    0% {
                      background-position: 0 11.6279069767%;
                    }
                    20% {
                      background-position: 30px 11.6279069767%;
                    }
                    22% {
                      background-position: -10px 11.6279069767%;
                    }
                    28.8% {
                      background-position: 15px 11.6279069767%;
                    }
                    37.6% {
                      background-position: -17px 11.6279069767%;
                    }
                    40% {
                      background-position: -22px 11.6279069767%;
                    }
                    56% {
                      background-position: 150px 11.6279069767%;
                    }
                    57.6% {
                      background-position: 26px 11.6279069767%;
                    }
                    68% {
                      background-position: 28px 11.6279069767%;
                    }
                    68.8% {
                      background-position: 0 11.6279069767%;
                    }
                    71.2% {
                      background-position: -5px 11.6279069767%;
                    }
                    73.6% {
                      background-position: -4px 11.6279069767%;
                    }
                    83.2% {
                      background-position: -105px 11.6279069767%;
                    }
                    100% {
                      background-position: 0 11.6279069767%;
                    }
                  }
                  .glitch-line:nth-child(7) {
                    position: absolute;
                    height: 2.3255%;
                    top: 13.953%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 13.9534883721%;
                    background-size: cover;
                    animation: smm-glitch7 0.6s -0.0976744186s linear infinite;
                  }
                  @keyframes smm-glitch7 {
                    0% {
                      background-position: 0 13.9534883721%;
                    }
                    20% {
                      background-position: 30px 13.9534883721%;
                    }
                    22% {
                      background-position: -10px 13.9534883721%;
                    }
                    28.8% {
                      background-position: 15px 13.9534883721%;
                    }
                    37.6% {
                      background-position: -17px 13.9534883721%;
                    }
                    40% {
                      background-position: -22px 13.9534883721%;
                    }
                    56% {
                      background-position: 150px 13.9534883721%;
                    }
                    57.6% {
                      background-position: 26px 13.9534883721%;
                    }
                    68% {
                      background-position: 28px 13.9534883721%;
                    }
                    68.8% {
                      background-position: 0 13.9534883721%;
                    }
                    71.2% {
                      background-position: -5px 13.9534883721%;
                    }
                    73.6% {
                      background-position: -4px 13.9534883721%;
                    }
                    83.2% {
                      background-position: -105px 13.9534883721%;
                    }
                    100% {
                      background-position: 0 13.9534883721%;
                    }
                  }
                  .glitch-line:nth-child(8) {
                    position: absolute;
                    height: 2.3255%;
                    top: 16.2785%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 16.2790697674%;
                    background-size: cover;
                    animation: smm-glitch8 0.6s -0.111627907s linear infinite;
                  }
                  @keyframes smm-glitch8 {
                    0% {
                      background-position: 0 16.2790697674%;
                    }
                    20% {
                      background-position: 30px 16.2790697674%;
                    }
                    22% {
                      background-position: -10px 16.2790697674%;
                    }
                    28.8% {
                      background-position: 15px 16.2790697674%;
                    }
                    37.6% {
                      background-position: -17px 16.2790697674%;
                    }
                    40% {
                      background-position: -22px 16.2790697674%;
                    }
                    56% {
                      background-position: 150px 16.2790697674%;
                    }
                    57.6% {
                      background-position: 26px 16.2790697674%;
                    }
                    68% {
                      background-position: 28px 16.2790697674%;
                    }
                    68.8% {
                      background-position: 0 16.2790697674%;
                    }
                    71.2% {
                      background-position: -5px 16.2790697674%;
                    }
                    73.6% {
                      background-position: -4px 16.2790697674%;
                    }
                    83.2% {
                      background-position: -105px 16.2790697674%;
                    }
                    100% {
                      background-position: 0 16.2790697674%;
                    }
                  }
                  .glitch-line:nth-child(9) {
                    position: absolute;
                    height: 2.3255%;
                    top: 18.604%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 18.6046511628%;
                    background-size: cover;
                    animation: smm-glitch9 0.6s -0.1255813953s linear infinite;
                  }
                  @keyframes smm-glitch9 {
                    0% {
                      background-position: 0 18.6046511628%;
                    }
                    20% {
                      background-position: 30px 18.6046511628%;
                    }
                    22% {
                      background-position: -10px 18.6046511628%;
                    }
                    28.8% {
                      background-position: 15px 18.6046511628%;
                    }
                    37.6% {
                      background-position: -17px 18.6046511628%;
                    }
                    40% {
                      background-position: -22px 18.6046511628%;
                    }
                    56% {
                      background-position: 150px 18.6046511628%;
                    }
                    57.6% {
                      background-position: 26px 18.6046511628%;
                    }
                    68% {
                      background-position: 28px 18.6046511628%;
                    }
                    68.8% {
                      background-position: 0 18.6046511628%;
                    }
                    71.2% {
                      background-position: -5px 18.6046511628%;
                    }
                    73.6% {
                      background-position: -4px 18.6046511628%;
                    }
                    83.2% {
                      background-position: -105px 18.6046511628%;
                    }
                    100% {
                      background-position: 0 18.6046511628%;
                    }
                  }
                  .glitch-line:nth-child(10) {
                    position: absolute;
                    height: 2.3255%;
                    top: 20.9295%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 20.9302325581%;
                    background-size: cover;
                    animation: smm-glitch10 0.6s -0.1395348837s linear infinite;
                  }
                  @keyframes smm-glitch10 {
                    0% {
                      background-position: 0 20.9302325581%;
                    }
                    20% {
                      background-position: 30px 20.9302325581%;
                    }
                    22% {
                      background-position: -10px 20.9302325581%;
                    }
                    28.8% {
                      background-position: 15px 20.9302325581%;
                    }
                    37.6% {
                      background-position: -17px 20.9302325581%;
                    }
                    40% {
                      background-position: -22px 20.9302325581%;
                    }
                    56% {
                      background-position: 150px 20.9302325581%;
                    }
                    57.6% {
                      background-position: 26px 20.9302325581%;
                    }
                    68% {
                      background-position: 28px 20.9302325581%;
                    }
                    68.8% {
                      background-position: 0 20.9302325581%;
                    }
                    71.2% {
                      background-position: -5px 20.9302325581%;
                    }
                    73.6% {
                      background-position: -4px 20.9302325581%;
                    }
                    83.2% {
                      background-position: -105px 20.9302325581%;
                    }
                    100% {
                      background-position: 0 20.9302325581%;
                    }
                  }
                  .glitch-line:nth-child(11) {
                    position: absolute;
                    height: 2.3255%;
                    top: 23.255%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 23.2558139535%;
                    background-size: cover;
                    animation: smm-glitch11 0.6s -0.1534883721s linear infinite;
                  }
                  @keyframes smm-glitch11 {
                    0% {
                      background-position: 0 23.2558139535%;
                    }
                    20% {
                      background-position: 30px 23.2558139535%;
                    }
                    22% {
                      background-position: -10px 23.2558139535%;
                    }
                    28.8% {
                      background-position: 15px 23.2558139535%;
                    }
                    37.6% {
                      background-position: -17px 23.2558139535%;
                    }
                    40% {
                      background-position: -22px 23.2558139535%;
                    }
                    56% {
                      background-position: 150px 23.2558139535%;
                    }
                    57.6% {
                      background-position: 26px 23.2558139535%;
                    }
                    68% {
                      background-position: 28px 23.2558139535%;
                    }
                    68.8% {
                      background-position: 0 23.2558139535%;
                    }
                    71.2% {
                      background-position: -5px 23.2558139535%;
                    }
                    73.6% {
                      background-position: -4px 23.2558139535%;
                    }
                    83.2% {
                      background-position: -105px 23.2558139535%;
                    }
                    100% {
                      background-position: 0 23.2558139535%;
                    }
                  }
                  .glitch-line:nth-child(12) {
                    position: absolute;
                    height: 2.3255%;
                    top: 25.5805%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 25.5813953488%;
                    background-size: cover;
                    animation: smm-glitch12 0.6s -0.1674418605s linear infinite;
                  }
                  @keyframes smm-glitch12 {
                    0% {
                      background-position: 0 25.5813953488%;
                    }
                    20% {
                      background-position: 30px 25.5813953488%;
                    }
                    22% {
                      background-position: -10px 25.5813953488%;
                    }
                    28.8% {
                      background-position: 15px 25.5813953488%;
                    }
                    37.6% {
                      background-position: -17px 25.5813953488%;
                    }
                    40% {
                      background-position: -22px 25.5813953488%;
                    }
                    56% {
                      background-position: 150px 25.5813953488%;
                    }
                    57.6% {
                      background-position: 26px 25.5813953488%;
                    }
                    68% {
                      background-position: 28px 25.5813953488%;
                    }
                    68.8% {
                      background-position: 0 25.5813953488%;
                    }
                    71.2% {
                      background-position: -5px 25.5813953488%;
                    }
                    73.6% {
                      background-position: -4px 25.5813953488%;
                    }
                    83.2% {
                      background-position: -105px 25.5813953488%;
                    }
                    100% {
                      background-position: 0 25.5813953488%;
                    }
                  }
                  .glitch-line:nth-child(13) {
                    position: absolute;
                    height: 2.3255%;
                    top: 27.906%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 27.9069767442%;
                    background-size: cover;
                    animation: smm-glitch13 0.6s -0.1813953488s linear infinite;
                  }
                  @keyframes smm-glitch13 {
                    0% {
                      background-position: 0 27.9069767442%;
                    }
                    20% {
                      background-position: 30px 27.9069767442%;
                    }
                    22% {
                      background-position: -10px 27.9069767442%;
                    }
                    28.8% {
                      background-position: 15px 27.9069767442%;
                    }
                    37.6% {
                      background-position: -17px 27.9069767442%;
                    }
                    40% {
                      background-position: -22px 27.9069767442%;
                    }
                    56% {
                      background-position: 150px 27.9069767442%;
                    }
                    57.6% {
                      background-position: 26px 27.9069767442%;
                    }
                    68% {
                      background-position: 28px 27.9069767442%;
                    }
                    68.8% {
                      background-position: 0 27.9069767442%;
                    }
                    71.2% {
                      background-position: -5px 27.9069767442%;
                    }
                    73.6% {
                      background-position: -4px 27.9069767442%;
                    }
                    83.2% {
                      background-position: -105px 27.9069767442%;
                    }
                    100% {
                      background-position: 0 27.9069767442%;
                    }
                  }
                  .glitch-line:nth-child(14) {
                    position: absolute;
                    height: 2.3255%;
                    top: 30.2315%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 30.2325581395%;
                    background-size: cover;
                    animation: smm-glitch14 0.6s -0.1953488372s linear infinite;
                  }
                  @keyframes smm-glitch14 {
                    0% {
                      background-position: 0 30.2325581395%;
                    }
                    20% {
                      background-position: 30px 30.2325581395%;
                    }
                    22% {
                      background-position: -10px 30.2325581395%;
                    }
                    28.8% {
                      background-position: 15px 30.2325581395%;
                    }
                    37.6% {
                      background-position: -17px 30.2325581395%;
                    }
                    40% {
                      background-position: -22px 30.2325581395%;
                    }
                    56% {
                      background-position: 150px 30.2325581395%;
                    }
                    57.6% {
                      background-position: 26px 30.2325581395%;
                    }
                    68% {
                      background-position: 28px 30.2325581395%;
                    }
                    68.8% {
                      background-position: 0 30.2325581395%;
                    }
                    71.2% {
                      background-position: -5px 30.2325581395%;
                    }
                    73.6% {
                      background-position: -4px 30.2325581395%;
                    }
                    83.2% {
                      background-position: -105px 30.2325581395%;
                    }
                    100% {
                      background-position: 0 30.2325581395%;
                    }
                  }
                  .glitch-line:nth-child(15) {
                    position: absolute;
                    height: 2.3255%;
                    top: 32.557%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 32.5581395349%;
                    background-size: cover;
                    animation: smm-glitch15 0.6s -0.2093023256s linear infinite;
                  }
                  @keyframes smm-glitch15 {
                    0% {
                      background-position: 0 32.5581395349%;
                    }
                    20% {
                      background-position: 30px 32.5581395349%;
                    }
                    22% {
                      background-position: -10px 32.5581395349%;
                    }
                    28.8% {
                      background-position: 15px 32.5581395349%;
                    }
                    37.6% {
                      background-position: -17px 32.5581395349%;
                    }
                    40% {
                      background-position: -22px 32.5581395349%;
                    }
                    56% {
                      background-position: 150px 32.5581395349%;
                    }
                    57.6% {
                      background-position: 26px 32.5581395349%;
                    }
                    68% {
                      background-position: 28px 32.5581395349%;
                    }
                    68.8% {
                      background-position: 0 32.5581395349%;
                    }
                    71.2% {
                      background-position: -5px 32.5581395349%;
                    }
                    73.6% {
                      background-position: -4px 32.5581395349%;
                    }
                    83.2% {
                      background-position: -105px 32.5581395349%;
                    }
                    100% {
                      background-position: 0 32.5581395349%;
                    }
                  }
                  .glitch-line:nth-child(16) {
                    position: absolute;
                    height: 2.3255%;
                    top: 34.8825%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 34.8837209302%;
                    background-size: cover;
                    animation: smm-glitch16 0.6s -0.223255814s linear infinite;
                  }
                  @keyframes smm-glitch16 {
                    0% {
                      background-position: 0 34.8837209302%;
                    }
                    20% {
                      background-position: 30px 34.8837209302%;
                    }
                    22% {
                      background-position: -10px 34.8837209302%;
                    }
                    28.8% {
                      background-position: 15px 34.8837209302%;
                    }
                    37.6% {
                      background-position: -17px 34.8837209302%;
                    }
                    40% {
                      background-position: -22px 34.8837209302%;
                    }
                    56% {
                      background-position: 150px 34.8837209302%;
                    }
                    57.6% {
                      background-position: 26px 34.8837209302%;
                    }
                    68% {
                      background-position: 28px 34.8837209302%;
                    }
                    68.8% {
                      background-position: 0 34.8837209302%;
                    }
                    71.2% {
                      background-position: -5px 34.8837209302%;
                    }
                    73.6% {
                      background-position: -4px 34.8837209302%;
                    }
                    83.2% {
                      background-position: -105px 34.8837209302%;
                    }
                    100% {
                      background-position: 0 34.8837209302%;
                    }
                  }
                  .glitch-line:nth-child(17) {
                    position: absolute;
                    height: 2.3255%;
                    top: 37.208%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 37.2093023256%;
                    background-size: cover;
                    animation: smm-glitch17 0.6s -0.2372093023s linear infinite;
                  }
                  @keyframes smm-glitch17 {
                    0% {
                      background-position: 0 37.2093023256%;
                    }
                    20% {
                      background-position: 30px 37.2093023256%;
                    }
                    22% {
                      background-position: -10px 37.2093023256%;
                    }
                    28.8% {
                      background-position: 15px 37.2093023256%;
                    }
                    37.6% {
                      background-position: -17px 37.2093023256%;
                    }
                    40% {
                      background-position: -22px 37.2093023256%;
                    }
                    56% {
                      background-position: 150px 37.2093023256%;
                    }
                    57.6% {
                      background-position: 26px 37.2093023256%;
                    }
                    68% {
                      background-position: 28px 37.2093023256%;
                    }
                    68.8% {
                      background-position: 0 37.2093023256%;
                    }
                    71.2% {
                      background-position: -5px 37.2093023256%;
                    }
                    73.6% {
                      background-position: -4px 37.2093023256%;
                    }
                    83.2% {
                      background-position: -105px 37.2093023256%;
                    }
                    100% {
                      background-position: 0 37.2093023256%;
                    }
                  }
                  .glitch-line:nth-child(18) {
                    position: absolute;
                    height: 2.3255%;
                    top: 39.5335%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 39.5348837209%;
                    background-size: cover;
                    animation: smm-glitch18 0.6s -0.2511627907s linear infinite;
                  }
                  @keyframes smm-glitch18 {
                    0% {
                      background-position: 0 39.5348837209%;
                    }
                    20% {
                      background-position: 30px 39.5348837209%;
                    }
                    22% {
                      background-position: -10px 39.5348837209%;
                    }
                    28.8% {
                      background-position: 15px 39.5348837209%;
                    }
                    37.6% {
                      background-position: -17px 39.5348837209%;
                    }
                    40% {
                      background-position: -22px 39.5348837209%;
                    }
                    56% {
                      background-position: 150px 39.5348837209%;
                    }
                    57.6% {
                      background-position: 26px 39.5348837209%;
                    }
                    68% {
                      background-position: 28px 39.5348837209%;
                    }
                    68.8% {
                      background-position: 0 39.5348837209%;
                    }
                    71.2% {
                      background-position: -5px 39.5348837209%;
                    }
                    73.6% {
                      background-position: -4px 39.5348837209%;
                    }
                    83.2% {
                      background-position: -105px 39.5348837209%;
                    }
                    100% {
                      background-position: 0 39.5348837209%;
                    }
                  }
                  .glitch-line:nth-child(19) {
                    position: absolute;
                    height: 2.3255%;
                    top: 41.859%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 41.8604651163%;
                    background-size: cover;
                    animation: smm-glitch19 0.6s -0.2651162791s linear infinite;
                  }
                  @keyframes smm-glitch19 {
                    0% {
                      background-position: 0 41.8604651163%;
                    }
                    20% {
                      background-position: 30px 41.8604651163%;
                    }
                    22% {
                      background-position: -10px 41.8604651163%;
                    }
                    28.8% {
                      background-position: 15px 41.8604651163%;
                    }
                    37.6% {
                      background-position: -17px 41.8604651163%;
                    }
                    40% {
                      background-position: -22px 41.8604651163%;
                    }
                    56% {
                      background-position: 150px 41.8604651163%;
                    }
                    57.6% {
                      background-position: 26px 41.8604651163%;
                    }
                    68% {
                      background-position: 28px 41.8604651163%;
                    }
                    68.8% {
                      background-position: 0 41.8604651163%;
                    }
                    71.2% {
                      background-position: -5px 41.8604651163%;
                    }
                    73.6% {
                      background-position: -4px 41.8604651163%;
                    }
                    83.2% {
                      background-position: -105px 41.8604651163%;
                    }
                    100% {
                      background-position: 0 41.8604651163%;
                    }
                  }
                  .glitch-line:nth-child(20) {
                    position: absolute;
                    height: 2.3255%;
                    top: 44.1845%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 44.1860465116%;
                    background-size: cover;
                    animation: smm-glitch20 0.6s -0.2790697674s linear infinite;
                  }
                  @keyframes smm-glitch20 {
                    0% {
                      background-position: 0 44.1860465116%;
                    }
                    20% {
                      background-position: 30px 44.1860465116%;
                    }
                    22% {
                      background-position: -10px 44.1860465116%;
                    }
                    28.8% {
                      background-position: 15px 44.1860465116%;
                    }
                    37.6% {
                      background-position: -17px 44.1860465116%;
                    }
                    40% {
                      background-position: -22px 44.1860465116%;
                    }
                    56% {
                      background-position: 150px 44.1860465116%;
                    }
                    57.6% {
                      background-position: 26px 44.1860465116%;
                    }
                    68% {
                      background-position: 28px 44.1860465116%;
                    }
                    68.8% {
                      background-position: 0 44.1860465116%;
                    }
                    71.2% {
                      background-position: -5px 44.1860465116%;
                    }
                    73.6% {
                      background-position: -4px 44.1860465116%;
                    }
                    83.2% {
                      background-position: -105px 44.1860465116%;
                    }
                    100% {
                      background-position: 0 44.1860465116%;
                    }
                  }
                  .glitch-line:nth-child(21) {
                    position: absolute;
                    height: 2.3255%;
                    top: 46.51%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 46.511627907%;
                    background-size: cover;
                    animation: smm-glitch21 0.6s -0.2930232558s linear infinite;
                  }
                  @keyframes smm-glitch21 {
                    0% {
                      background-position: 0 46.511627907%;
                    }
                    20% {
                      background-position: 30px 46.511627907%;
                    }
                    22% {
                      background-position: -10px 46.511627907%;
                    }
                    28.8% {
                      background-position: 15px 46.511627907%;
                    }
                    37.6% {
                      background-position: -17px 46.511627907%;
                    }
                    40% {
                      background-position: -22px 46.511627907%;
                    }
                    56% {
                      background-position: 150px 46.511627907%;
                    }
                    57.6% {
                      background-position: 26px 46.511627907%;
                    }
                    68% {
                      background-position: 28px 46.511627907%;
                    }
                    68.8% {
                      background-position: 0 46.511627907%;
                    }
                    71.2% {
                      background-position: -5px 46.511627907%;
                    }
                    73.6% {
                      background-position: -4px 46.511627907%;
                    }
                    83.2% {
                      background-position: -105px 46.511627907%;
                    }
                    100% {
                      background-position: 0 46.511627907%;
                    }
                  }
                  .glitch-line:nth-child(22) {
                    position: absolute;
                    height: 2.3255%;
                    top: 48.8355%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 48.8372093023%;
                    background-size: cover;
                    animation: smm-glitch22 0.6s -0.3069767442s linear infinite;
                  }
                  @keyframes smm-glitch22 {
                    0% {
                      background-position: 0 48.8372093023%;
                    }
                    20% {
                      background-position: 30px 48.8372093023%;
                    }
                    22% {
                      background-position: -10px 48.8372093023%;
                    }
                    28.8% {
                      background-position: 15px 48.8372093023%;
                    }
                    37.6% {
                      background-position: -17px 48.8372093023%;
                    }
                    40% {
                      background-position: -22px 48.8372093023%;
                    }
                    56% {
                      background-position: 150px 48.8372093023%;
                    }
                    57.6% {
                      background-position: 26px 48.8372093023%;
                    }
                    68% {
                      background-position: 28px 48.8372093023%;
                    }
                    68.8% {
                      background-position: 0 48.8372093023%;
                    }
                    71.2% {
                      background-position: -5px 48.8372093023%;
                    }
                    73.6% {
                      background-position: -4px 48.8372093023%;
                    }
                    83.2% {
                      background-position: -105px 48.8372093023%;
                    }
                    100% {
                      background-position: 0 48.8372093023%;
                    }
                  }
                  .glitch-line:nth-child(23) {
                    position: absolute;
                    height: 2.3255%;
                    top: 51.161%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 51.1627906977%;
                    background-size: cover;
                    animation: smm-glitch23 0.6s -0.3209302326s linear infinite;
                  }
                  @keyframes smm-glitch23 {
                    0% {
                      background-position: 0 51.1627906977%;
                    }
                    20% {
                      background-position: 30px 51.1627906977%;
                    }
                    22% {
                      background-position: -10px 51.1627906977%;
                    }
                    28.8% {
                      background-position: 15px 51.1627906977%;
                    }
                    37.6% {
                      background-position: -17px 51.1627906977%;
                    }
                    40% {
                      background-position: -22px 51.1627906977%;
                    }
                    56% {
                      background-position: 150px 51.1627906977%;
                    }
                    57.6% {
                      background-position: 26px 51.1627906977%;
                    }
                    68% {
                      background-position: 28px 51.1627906977%;
                    }
                    68.8% {
                      background-position: 0 51.1627906977%;
                    }
                    71.2% {
                      background-position: -5px 51.1627906977%;
                    }
                    73.6% {
                      background-position: -4px 51.1627906977%;
                    }
                    83.2% {
                      background-position: -105px 51.1627906977%;
                    }
                    100% {
                      background-position: 0 51.1627906977%;
                    }
                  }
                  .glitch-line:nth-child(24) {
                    position: absolute;
                    height: 2.3255%;
                    top: 53.4865%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 53.488372093%;
                    background-size: cover;
                    animation: smm-glitch24 0.6s -0.3348837209s linear infinite;
                  }
                  @keyframes smm-glitch24 {
                    0% {
                      background-position: 0 53.488372093%;
                    }
                    20% {
                      background-position: 30px 53.488372093%;
                    }
                    22% {
                      background-position: -10px 53.488372093%;
                    }
                    28.8% {
                      background-position: 15px 53.488372093%;
                    }
                    37.6% {
                      background-position: -17px 53.488372093%;
                    }
                    40% {
                      background-position: -22px 53.488372093%;
                    }
                    56% {
                      background-position: 150px 53.488372093%;
                    }
                    57.6% {
                      background-position: 26px 53.488372093%;
                    }
                    68% {
                      background-position: 28px 53.488372093%;
                    }
                    68.8% {
                      background-position: 0 53.488372093%;
                    }
                    71.2% {
                      background-position: -5px 53.488372093%;
                    }
                    73.6% {
                      background-position: -4px 53.488372093%;
                    }
                    83.2% {
                      background-position: -105px 53.488372093%;
                    }
                    100% {
                      background-position: 0 53.488372093%;
                    }
                  }
                  .glitch-line:nth-child(25) {
                    position: absolute;
                    height: 2.3255%;
                    top: 55.812%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 55.8139534884%;
                    background-size: cover;
                    animation: smm-glitch25 0.6s -0.3488372093s linear infinite;
                  }
                  @keyframes smm-glitch25 {
                    0% {
                      background-position: 0 55.8139534884%;
                    }
                    20% {
                      background-position: 30px 55.8139534884%;
                    }
                    22% {
                      background-position: -10px 55.8139534884%;
                    }
                    28.8% {
                      background-position: 15px 55.8139534884%;
                    }
                    37.6% {
                      background-position: -17px 55.8139534884%;
                    }
                    40% {
                      background-position: -22px 55.8139534884%;
                    }
                    56% {
                      background-position: 150px 55.8139534884%;
                    }
                    57.6% {
                      background-position: 26px 55.8139534884%;
                    }
                    68% {
                      background-position: 28px 55.8139534884%;
                    }
                    68.8% {
                      background-position: 0 55.8139534884%;
                    }
                    71.2% {
                      background-position: -5px 55.8139534884%;
                    }
                    73.6% {
                      background-position: -4px 55.8139534884%;
                    }
                    83.2% {
                      background-position: -105px 55.8139534884%;
                    }
                    100% {
                      background-position: 0 55.8139534884%;
                    }
                  }
                  .glitch-line:nth-child(26) {
                    position: absolute;
                    height: 2.3255%;
                    top: 58.1375%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 58.1395348837%;
                    background-size: cover;
                    animation: smm-glitch26 0.6s -0.3627906977s linear infinite;
                  }
                  @keyframes smm-glitch26 {
                    0% {
                      background-position: 0 58.1395348837%;
                    }
                    20% {
                      background-position: 30px 58.1395348837%;
                    }
                    22% {
                      background-position: -10px 58.1395348837%;
                    }
                    28.8% {
                      background-position: 15px 58.1395348837%;
                    }
                    37.6% {
                      background-position: -17px 58.1395348837%;
                    }
                    40% {
                      background-position: -22px 58.1395348837%;
                    }
                    56% {
                      background-position: 150px 58.1395348837%;
                    }
                    57.6% {
                      background-position: 26px 58.1395348837%;
                    }
                    68% {
                      background-position: 28px 58.1395348837%;
                    }
                    68.8% {
                      background-position: 0 58.1395348837%;
                    }
                    71.2% {
                      background-position: -5px 58.1395348837%;
                    }
                    73.6% {
                      background-position: -4px 58.1395348837%;
                    }
                    83.2% {
                      background-position: -105px 58.1395348837%;
                    }
                    100% {
                      background-position: 0 58.1395348837%;
                    }
                  }
                  .glitch-line:nth-child(27) {
                    position: absolute;
                    height: 2.3255%;
                    top: 60.463%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 60.4651162791%;
                    background-size: cover;
                    animation: smm-glitch27 0.6s -0.376744186s linear infinite;
                  }
                  @keyframes smm-glitch27 {
                    0% {
                      background-position: 0 60.4651162791%;
                    }
                    20% {
                      background-position: 30px 60.4651162791%;
                    }
                    22% {
                      background-position: -10px 60.4651162791%;
                    }
                    28.8% {
                      background-position: 15px 60.4651162791%;
                    }
                    37.6% {
                      background-position: -17px 60.4651162791%;
                    }
                    40% {
                      background-position: -22px 60.4651162791%;
                    }
                    56% {
                      background-position: 150px 60.4651162791%;
                    }
                    57.6% {
                      background-position: 26px 60.4651162791%;
                    }
                    68% {
                      background-position: 28px 60.4651162791%;
                    }
                    68.8% {
                      background-position: 0 60.4651162791%;
                    }
                    71.2% {
                      background-position: -5px 60.4651162791%;
                    }
                    73.6% {
                      background-position: -4px 60.4651162791%;
                    }
                    83.2% {
                      background-position: -105px 60.4651162791%;
                    }
                    100% {
                      background-position: 0 60.4651162791%;
                    }
                  }
                  .glitch-line:nth-child(28) {
                    position: absolute;
                    height: 2.3255%;
                    top: 62.7885%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 62.7906976744%;
                    background-size: cover;
                    animation: smm-glitch28 0.6s -0.3906976744s linear infinite;
                  }
                  @keyframes smm-glitch28 {
                    0% {
                      background-position: 0 62.7906976744%;
                    }
                    20% {
                      background-position: 30px 62.7906976744%;
                    }
                    22% {
                      background-position: -10px 62.7906976744%;
                    }
                    28.8% {
                      background-position: 15px 62.7906976744%;
                    }
                    37.6% {
                      background-position: -17px 62.7906976744%;
                    }
                    40% {
                      background-position: -22px 62.7906976744%;
                    }
                    56% {
                      background-position: 150px 62.7906976744%;
                    }
                    57.6% {
                      background-position: 26px 62.7906976744%;
                    }
                    68% {
                      background-position: 28px 62.7906976744%;
                    }
                    68.8% {
                      background-position: 0 62.7906976744%;
                    }
                    71.2% {
                      background-position: -5px 62.7906976744%;
                    }
                    73.6% {
                      background-position: -4px 62.7906976744%;
                    }
                    83.2% {
                      background-position: -105px 62.7906976744%;
                    }
                    100% {
                      background-position: 0 62.7906976744%;
                    }
                  }
                  .glitch-line:nth-child(29) {
                    position: absolute;
                    height: 2.3255%;
                    top: 65.114%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 65.1162790698%;
                    background-size: cover;
                    animation: smm-glitch29 0.6s -0.4046511628s linear infinite;
                  }
                  @keyframes smm-glitch29 {
                    0% {
                      background-position: 0 65.1162790698%;
                    }
                    20% {
                      background-position: 30px 65.1162790698%;
                    }
                    22% {
                      background-position: -10px 65.1162790698%;
                    }
                    28.8% {
                      background-position: 15px 65.1162790698%;
                    }
                    37.6% {
                      background-position: -17px 65.1162790698%;
                    }
                    40% {
                      background-position: -22px 65.1162790698%;
                    }
                    56% {
                      background-position: 150px 65.1162790698%;
                    }
                    57.6% {
                      background-position: 26px 65.1162790698%;
                    }
                    68% {
                      background-position: 28px 65.1162790698%;
                    }
                    68.8% {
                      background-position: 0 65.1162790698%;
                    }
                    71.2% {
                      background-position: -5px 65.1162790698%;
                    }
                    73.6% {
                      background-position: -4px 65.1162790698%;
                    }
                    83.2% {
                      background-position: -105px 65.1162790698%;
                    }
                    100% {
                      background-position: 0 65.1162790698%;
                    }
                  }
                  .glitch-line:nth-child(30) {
                    position: absolute;
                    height: 2.3255%;
                    top: 67.4395%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 67.4418604651%;
                    background-size: cover;
                    animation: smm-glitch30 0.6s -0.4186046512s linear infinite;
                  }
                  @keyframes smm-glitch30 {
                    0% {
                      background-position: 0 67.4418604651%;
                    }
                    20% {
                      background-position: 30px 67.4418604651%;
                    }
                    22% {
                      background-position: -10px 67.4418604651%;
                    }
                    28.8% {
                      background-position: 15px 67.4418604651%;
                    }
                    37.6% {
                      background-position: -17px 67.4418604651%;
                    }
                    40% {
                      background-position: -22px 67.4418604651%;
                    }
                    56% {
                      background-position: 150px 67.4418604651%;
                    }
                    57.6% {
                      background-position: 26px 67.4418604651%;
                    }
                    68% {
                      background-position: 28px 67.4418604651%;
                    }
                    68.8% {
                      background-position: 0 67.4418604651%;
                    }
                    71.2% {
                      background-position: -5px 67.4418604651%;
                    }
                    73.6% {
                      background-position: -4px 67.4418604651%;
                    }
                    83.2% {
                      background-position: -105px 67.4418604651%;
                    }
                    100% {
                      background-position: 0 67.4418604651%;
                    }
                  }
                  .glitch-line:nth-child(31) {
                    position: absolute;
                    height: 2.3255%;
                    top: 69.765%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 69.7674418605%;
                    background-size: cover;
                    animation: smm-glitch31 0.6s -0.4325581395s linear infinite;
                  }
                  @keyframes smm-glitch31 {
                    0% {
                      background-position: 0 69.7674418605%;
                    }
                    20% {
                      background-position: 30px 69.7674418605%;
                    }
                    22% {
                      background-position: -10px 69.7674418605%;
                    }
                    28.8% {
                      background-position: 15px 69.7674418605%;
                    }
                    37.6% {
                      background-position: -17px 69.7674418605%;
                    }
                    40% {
                      background-position: -22px 69.7674418605%;
                    }
                    56% {
                      background-position: 150px 69.7674418605%;
                    }
                    57.6% {
                      background-position: 26px 69.7674418605%;
                    }
                    68% {
                      background-position: 28px 69.7674418605%;
                    }
                    68.8% {
                      background-position: 0 69.7674418605%;
                    }
                    71.2% {
                      background-position: -5px 69.7674418605%;
                    }
                    73.6% {
                      background-position: -4px 69.7674418605%;
                    }
                    83.2% {
                      background-position: -105px 69.7674418605%;
                    }
                    100% {
                      background-position: 0 69.7674418605%;
                    }
                  }
                  .glitch-line:nth-child(32) {
                    position: absolute;
                    height: 2.3255%;
                    top: 72.0905%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 72.0930232558%;
                    background-size: cover;
                    animation: smm-glitch32 0.6s -0.4465116279s linear infinite;
                  }
                  @keyframes smm-glitch32 {
                    0% {
                      background-position: 0 72.0930232558%;
                    }
                    20% {
                      background-position: 30px 72.0930232558%;
                    }
                    22% {
                      background-position: -10px 72.0930232558%;
                    }
                    28.8% {
                      background-position: 15px 72.0930232558%;
                    }
                    37.6% {
                      background-position: -17px 72.0930232558%;
                    }
                    40% {
                      background-position: -22px 72.0930232558%;
                    }
                    56% {
                      background-position: 150px 72.0930232558%;
                    }
                    57.6% {
                      background-position: 26px 72.0930232558%;
                    }
                    68% {
                      background-position: 28px 72.0930232558%;
                    }
                    68.8% {
                      background-position: 0 72.0930232558%;
                    }
                    71.2% {
                      background-position: -5px 72.0930232558%;
                    }
                    73.6% {
                      background-position: -4px 72.0930232558%;
                    }
                    83.2% {
                      background-position: -105px 72.0930232558%;
                    }
                    100% {
                      background-position: 0 72.0930232558%;
                    }
                  }
                  .glitch-line:nth-child(33) {
                    position: absolute;
                    height: 2.3255%;
                    top: 74.416%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 74.4186046512%;
                    background-size: cover;
                    animation: smm-glitch33 0.6s -0.4604651163s linear infinite;
                  }
                  @keyframes smm-glitch33 {
                    0% {
                      background-position: 0 74.4186046512%;
                    }
                    20% {
                      background-position: 30px 74.4186046512%;
                    }
                    22% {
                      background-position: -10px 74.4186046512%;
                    }
                    28.8% {
                      background-position: 15px 74.4186046512%;
                    }
                    37.6% {
                      background-position: -17px 74.4186046512%;
                    }
                    40% {
                      background-position: -22px 74.4186046512%;
                    }
                    56% {
                      background-position: 150px 74.4186046512%;
                    }
                    57.6% {
                      background-position: 26px 74.4186046512%;
                    }
                    68% {
                      background-position: 28px 74.4186046512%;
                    }
                    68.8% {
                      background-position: 0 74.4186046512%;
                    }
                    71.2% {
                      background-position: -5px 74.4186046512%;
                    }
                    73.6% {
                      background-position: -4px 74.4186046512%;
                    }
                    83.2% {
                      background-position: -105px 74.4186046512%;
                    }
                    100% {
                      background-position: 0 74.4186046512%;
                    }
                  }
                  .glitch-line:nth-child(34) {
                    position: absolute;
                    height: 2.3255%;
                    top: 76.7415%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 76.7441860465%;
                    background-size: cover;
                    animation: smm-glitch34 0.6s -0.4744186047s linear infinite;
                  }
                  @keyframes smm-glitch34 {
                    0% {
                      background-position: 0 76.7441860465%;
                    }
                    20% {
                      background-position: 30px 76.7441860465%;
                    }
                    22% {
                      background-position: -10px 76.7441860465%;
                    }
                    28.8% {
                      background-position: 15px 76.7441860465%;
                    }
                    37.6% {
                      background-position: -17px 76.7441860465%;
                    }
                    40% {
                      background-position: -22px 76.7441860465%;
                    }
                    56% {
                      background-position: 150px 76.7441860465%;
                    }
                    57.6% {
                      background-position: 26px 76.7441860465%;
                    }
                    68% {
                      background-position: 28px 76.7441860465%;
                    }
                    68.8% {
                      background-position: 0 76.7441860465%;
                    }
                    71.2% {
                      background-position: -5px 76.7441860465%;
                    }
                    73.6% {
                      background-position: -4px 76.7441860465%;
                    }
                    83.2% {
                      background-position: -105px 76.7441860465%;
                    }
                    100% {
                      background-position: 0 76.7441860465%;
                    }
                  }
                  .glitch-line:nth-child(35) {
                    position: absolute;
                    height: 2.3255%;
                    top: 79.067%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 79.0697674419%;
                    background-size: cover;
                    animation: smm-glitch35 0.6s -0.488372093s linear infinite;
                  }
                  @keyframes smm-glitch35 {
                    0% {
                      background-position: 0 79.0697674419%;
                    }
                    20% {
                      background-position: 30px 79.0697674419%;
                    }
                    22% {
                      background-position: -10px 79.0697674419%;
                    }
                    28.8% {
                      background-position: 15px 79.0697674419%;
                    }
                    37.6% {
                      background-position: -17px 79.0697674419%;
                    }
                    40% {
                      background-position: -22px 79.0697674419%;
                    }
                    56% {
                      background-position: 150px 79.0697674419%;
                    }
                    57.6% {
                      background-position: 26px 79.0697674419%;
                    }
                    68% {
                      background-position: 28px 79.0697674419%;
                    }
                    68.8% {
                      background-position: 0 79.0697674419%;
                    }
                    71.2% {
                      background-position: -5px 79.0697674419%;
                    }
                    73.6% {
                      background-position: -4px 79.0697674419%;
                    }
                    83.2% {
                      background-position: -105px 79.0697674419%;
                    }
                    100% {
                      background-position: 0 79.0697674419%;
                    }
                  }
                  .glitch-line:nth-child(36) {
                    position: absolute;
                    height: 2.3255%;
                    top: 81.3925%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 81.3953488372%;
                    background-size: cover;
                    animation: smm-glitch36 0.6s -0.5023255814s linear infinite;
                  }
                  @keyframes smm-glitch36 {
                    0% {
                      background-position: 0 81.3953488372%;
                    }
                    20% {
                      background-position: 30px 81.3953488372%;
                    }
                    22% {
                      background-position: -10px 81.3953488372%;
                    }
                    28.8% {
                      background-position: 15px 81.3953488372%;
                    }
                    37.6% {
                      background-position: -17px 81.3953488372%;
                    }
                    40% {
                      background-position: -22px 81.3953488372%;
                    }
                    56% {
                      background-position: 150px 81.3953488372%;
                    }
                    57.6% {
                      background-position: 26px 81.3953488372%;
                    }
                    68% {
                      background-position: 28px 81.3953488372%;
                    }
                    68.8% {
                      background-position: 0 81.3953488372%;
                    }
                    71.2% {
                      background-position: -5px 81.3953488372%;
                    }
                    73.6% {
                      background-position: -4px 81.3953488372%;
                    }
                    83.2% {
                      background-position: -105px 81.3953488372%;
                    }
                    100% {
                      background-position: 0 81.3953488372%;
                    }
                  }
                  .glitch-line:nth-child(37) {
                    position: absolute;
                    height: 2.3255%;
                    top: 83.718%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 83.7209302326%;
                    background-size: cover;
                    animation: smm-glitch37 0.6s -0.5162790698s linear infinite;
                  }
                  @keyframes smm-glitch37 {
                    0% {
                      background-position: 0 83.7209302326%;
                    }
                    20% {
                      background-position: 30px 83.7209302326%;
                    }
                    22% {
                      background-position: -10px 83.7209302326%;
                    }
                    28.8% {
                      background-position: 15px 83.7209302326%;
                    }
                    37.6% {
                      background-position: -17px 83.7209302326%;
                    }
                    40% {
                      background-position: -22px 83.7209302326%;
                    }
                    56% {
                      background-position: 150px 83.7209302326%;
                    }
                    57.6% {
                      background-position: 26px 83.7209302326%;
                    }
                    68% {
                      background-position: 28px 83.7209302326%;
                    }
                    68.8% {
                      background-position: 0 83.7209302326%;
                    }
                    71.2% {
                      background-position: -5px 83.7209302326%;
                    }
                    73.6% {
                      background-position: -4px 83.7209302326%;
                    }
                    83.2% {
                      background-position: -105px 83.7209302326%;
                    }
                    100% {
                      background-position: 0 83.7209302326%;
                    }
                  }
                  .glitch-line:nth-child(38) {
                    position: absolute;
                    height: 2.3255%;
                    top: 86.0435%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 86.0465116279%;
                    background-size: cover;
                    animation: smm-glitch38 0.6s -0.5302325581s linear infinite;
                  }
                  @keyframes smm-glitch38 {
                    0% {
                      background-position: 0 86.0465116279%;
                    }
                    20% {
                      background-position: 30px 86.0465116279%;
                    }
                    22% {
                      background-position: -10px 86.0465116279%;
                    }
                    28.8% {
                      background-position: 15px 86.0465116279%;
                    }
                    37.6% {
                      background-position: -17px 86.0465116279%;
                    }
                    40% {
                      background-position: -22px 86.0465116279%;
                    }
                    56% {
                      background-position: 150px 86.0465116279%;
                    }
                    57.6% {
                      background-position: 26px 86.0465116279%;
                    }
                    68% {
                      background-position: 28px 86.0465116279%;
                    }
                    68.8% {
                      background-position: 0 86.0465116279%;
                    }
                    71.2% {
                      background-position: -5px 86.0465116279%;
                    }
                    73.6% {
                      background-position: -4px 86.0465116279%;
                    }
                    83.2% {
                      background-position: -105px 86.0465116279%;
                    }
                    100% {
                      background-position: 0 86.0465116279%;
                    }
                  }
                  .glitch-line:nth-child(39) {
                    position: absolute;
                    height: 2.3255%;
                    top: 88.369%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 88.3720930233%;
                    background-size: cover;
                    animation: smm-glitch39 0.6s -0.5441860465s linear infinite;
                  }
                  @keyframes smm-glitch39 {
                    0% {
                      background-position: 0 88.3720930233%;
                    }
                    20% {
                      background-position: 30px 88.3720930233%;
                    }
                    22% {
                      background-position: -10px 88.3720930233%;
                    }
                    28.8% {
                      background-position: 15px 88.3720930233%;
                    }
                    37.6% {
                      background-position: -17px 88.3720930233%;
                    }
                    40% {
                      background-position: -22px 88.3720930233%;
                    }
                    56% {
                      background-position: 150px 88.3720930233%;
                    }
                    57.6% {
                      background-position: 26px 88.3720930233%;
                    }
                    68% {
                      background-position: 28px 88.3720930233%;
                    }
                    68.8% {
                      background-position: 0 88.3720930233%;
                    }
                    71.2% {
                      background-position: -5px 88.3720930233%;
                    }
                    73.6% {
                      background-position: -4px 88.3720930233%;
                    }
                    83.2% {
                      background-position: -105px 88.3720930233%;
                    }
                    100% {
                      background-position: 0 88.3720930233%;
                    }
                  }
                  .glitch-line:nth-child(40) {
                    position: absolute;
                    height: 2.3255%;
                    top: 90.6945%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 90.6976744186%;
                    background-size: cover;
                    animation: smm-glitch40 0.6s -0.5581395349s linear infinite;
                  }
                  @keyframes smm-glitch40 {
                    0% {
                      background-position: 0 90.6976744186%;
                    }
                    20% {
                      background-position: 30px 90.6976744186%;
                    }
                    22% {
                      background-position: -10px 90.6976744186%;
                    }
                    28.8% {
                      background-position: 15px 90.6976744186%;
                    }
                    37.6% {
                      background-position: -17px 90.6976744186%;
                    }
                    40% {
                      background-position: -22px 90.6976744186%;
                    }
                    56% {
                      background-position: 150px 90.6976744186%;
                    }
                    57.6% {
                      background-position: 26px 90.6976744186%;
                    }
                    68% {
                      background-position: 28px 90.6976744186%;
                    }
                    68.8% {
                      background-position: 0 90.6976744186%;
                    }
                    71.2% {
                      background-position: -5px 90.6976744186%;
                    }
                    73.6% {
                      background-position: -4px 90.6976744186%;
                    }
                    83.2% {
                      background-position: -105px 90.6976744186%;
                    }
                    100% {
                      background-position: 0 90.6976744186%;
                    }
                  }
                  .glitch-line:nth-child(41) {
                    position: absolute;
                    height: 2.3255%;
                    top: 93.02%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 93.023255814%;
                    background-size: cover;
                    animation: smm-glitch41 0.6s -0.5720930233s linear infinite;
                  }
                  @keyframes smm-glitch41 {
                    0% {
                      background-position: 0 93.023255814%;
                    }
                    20% {
                      background-position: 30px 93.023255814%;
                    }
                    22% {
                      background-position: -10px 93.023255814%;
                    }
                    28.8% {
                      background-position: 15px 93.023255814%;
                    }
                    37.6% {
                      background-position: -17px 93.023255814%;
                    }
                    40% {
                      background-position: -22px 93.023255814%;
                    }
                    56% {
                      background-position: 150px 93.023255814%;
                    }
                    57.6% {
                      background-position: 26px 93.023255814%;
                    }
                    68% {
                      background-position: 28px 93.023255814%;
                    }
                    68.8% {
                      background-position: 0 93.023255814%;
                    }
                    71.2% {
                      background-position: -5px 93.023255814%;
                    }
                    73.6% {
                      background-position: -4px 93.023255814%;
                    }
                    83.2% {
                      background-position: -105px 93.023255814%;
                    }
                    100% {
                      background-position: 0 93.023255814%;
                    }
                  }
                  .glitch-line:nth-child(42) {
                    position: absolute;
                    height: 2.3255%;
                    top: 95.3455%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 95.3488372093%;
                    background-size: cover;
                    animation: smm-glitch42 0.6s -0.5860465116s linear infinite;
                  }
                  @keyframes smm-glitch42 {
                    0% {
                      background-position: 0 95.3488372093%;
                    }
                    20% {
                      background-position: 30px 95.3488372093%;
                    }
                    22% {
                      background-position: -10px 95.3488372093%;
                    }
                    28.8% {
                      background-position: 15px 95.3488372093%;
                    }
                    37.6% {
                      background-position: -17px 95.3488372093%;
                    }
                    40% {
                      background-position: -22px 95.3488372093%;
                    }
                    56% {
                      background-position: 150px 95.3488372093%;
                    }
                    57.6% {
                      background-position: 26px 95.3488372093%;
                    }
                    68% {
                      background-position: 28px 95.3488372093%;
                    }
                    68.8% {
                      background-position: 0 95.3488372093%;
                    }
                    71.2% {
                      background-position: -5px 95.3488372093%;
                    }
                    73.6% {
                      background-position: -4px 95.3488372093%;
                    }
                    83.2% {
                      background-position: -105px 95.3488372093%;
                    }
                    100% {
                      background-position: 0 95.3488372093%;
                    }
                  }
                  .glitch-line:nth-child(43) {
                    position: absolute;
                    height: 2.3255%;
                    top: 97.671%;
                    width: 100%;
                    background: url('https://weprodigi.com/uploads/images/smm/glitch.png');
                    background-position: 0 97.6744186047%;
                    background-size: cover;
                    animation: smm-glitch43 0.6s -0.6s linear infinite;
                  }
                  @keyframes smm-glitch43 {
                    0% {
                      background-position: 0 97.6744186047%;
                    }
                    20% {
                      background-position: 30px 97.6744186047%;
                    }
                    22% {
                      background-position: -10px 97.6744186047%;
                    }
                    28.8% {
                      background-position: 15px 97.6744186047%;
                    }
                    37.6% {
                      background-position: -17px 97.6744186047%;
                    }
                    40% {
                      background-position: -22px 97.6744186047%;
                    }
                    56% {
                      background-position: 150px 97.6744186047%;
                    }
                    57.6% {
                      background-position: 26px 97.6744186047%;
                    }
                    68% {
                      background-position: 28px 97.6744186047%;
                    }
                    68.8% {
                      background-position: 0 97.6744186047%;
                    }
                    71.2% {
                      background-position: -5px 97.6744186047%;
                    }
                    73.6% {
                      background-position: -4px 97.6744186047%;
                    }
                    83.2% {
                      background-position: -105px 97.6744186047%;
                    }
                    100% {
                      background-position: 0 97.6744186047%;
                    }
                  }
                  @keyframes wave {
                    00% {
                      transform: translateY(0em);
                    }
                    60% {
                      transform: translateY(-0.6em);
                    }
                    100% {
                      transform: translateY(0em);
                    }
                  }
                  @media screen and (min-width: 768px) and (max-width: 1100px) {
                    .fb-animation-text {
                      font-size: 5vw !important;
                    }
                    .insta-animation-text {
                      font-size: 4.5vw !important;
                    }
                    .linkedin-animation-text {
                      font-size: 5.5vw !important;
                    }
                    .snapchat-animation-text {
                      font-size: 5vw !important;
                    }
                    .x-animation-text {
                      font-size: 6vw !important;
                    }
                  }
                  @media screen and (max-width: 768px) {
                    .fb-animation-text {
                      font-size: 6vw !important;
                    }
                    .insta-animation-text {
                      font-size: 5vw !important;
                    }
                    .linkedin-animation-text {
                      font-size: 6.5vw !important;
                    }
                    .snapchat-animation-text {
                      font-size: 6vw !important;
                    }
                    .x-animation-text {
                      font-size: 7.5vw !important;
                    }
                  }
                `}</style>
              </div>
            </div>
          </div>
          <div id="bar" className="absolute bottom-0 z-50 flex-row hidden w-full md:flex bg-purple py-15">
            <div className="flex-row md:container md:px-0 md:flex">
              <div
                className="flex items-center justify-center flex-grow py-5 text-center text-white transition-all border-r border-white cursor-pointer intro-link text-16 md:text-13 lg:text-16 hover:text-green"
                onClick={() => this.scrollToPlatform('facebook', 40)}
              >
                Facebook marketing
              </div>
              <div
                className="flex items-center justify-center flex-grow py-5 text-center text-white transition-all border-l border-r border-white cursor-pointer intro-link text-16 md:text-13 lg:text-16 hover:text-green"
                onClick={() => this.scrollToPlatform('instagram', 40)}
              >
                Instagram marketing
              </div>
              <div
                className="flex items-center justify-center flex-grow py-5 text-center text-white transition-all border-l border-r border-white cursor-pointer intro-link text-16 md:text-13 lg:text-16 hover:text-green"
                onClick={() => this.scrollToPlatform('linkedin', 40)}
              >
                LinkedIn marketing
              </div>
              <div
                className="flex items-center justify-center flex-grow py-5 text-center text-white transition-all border-l border-r border-white cursor-pointer intro-link text-16 md:text-13 lg:text-16 hover:text-green"
                onClick={() => this.scrollToPlatform('snapchat', 40)}
              >
                Snapchat marketing
              </div>
              <div
                className="flex items-center justify-center flex-grow py-5 text-center text-white transition-all border-l border-white cursor-pointer intro-link text-16 md:text-13 lg:text-16 hover:text-green"
                onClick={() => this.scrollToPlatform('x', 40)}
              >
                X marketing
              </div>
            </div>
          </div>
        </div>
        <div className="relative engagement py-23 md:bg-white">
          <div className="container">
            <Engagement title="Video">
              You have succeeded to appear on one of the most experienced social media management company’s page. Due to our comprehensive approach in
              developing customized and competitive social media marketing service plans, more than 350 companies have built brand awareness and
              generated revenue on social media platforms such as Facebook, Instagram, LinkedIn and others. It comes true when you use our SMM
              services which include Strategy Development, Content Creation, Community Management, Ads Management, Reporting and Analytics. Therefore,
              by choosing us you'll get a partner who is experienced and certified in offering such services to small and medium-sized businesses in
              over 20 industries, including healthcare, beauty and fashion, transportation, insurance, telecommunications, finance, construction, as
              well as non-profit organizations working in education, entertainment, and other fields.<br></br>
              WE VALUE YOUR TIME, and want you to make use of your time effectively, that’s why in this page you will find all the information
              regarding our SMM services.
            </Engagement>
            {/*<Link href="/quote/smm">*/}
            {/*    <a href="/quote/smm"*/}
            {/*       className="block py-5 mt-20 text-center transition-all border get-smm-proposal-button md:hidden rounded-5 border-purple text-18 text-purple px-23 hover:bg-purple hover:text-white icon-calculator-container transition-400"><span*/}
            {/*        className="icon icon-calculator"></span>Get your proposal</a>*/}
            {/*</Link>*/}
            <div className={'flex flex-col'}>
              <a
                onClick={() => this.showSMMPricing(null)}
                className="relative z-10 block py-5 overflow-hidden transition-all border-2 cursor-pointer get-smm-proposal-button md:hidden rounded-5 border-purple text-18 text-purple px-23 mt-23 icon-paper-container transition-400"
              >
                <span className="icon icon-pricing" />
                <span className="block text-center text">Get Pricing</span>
              </a>
              {/*<a onClick={() => this.showSMMCustomProposal(null)}*/}
              {/*   className="relative z-10 block py-5 overflow-hidden transition-all border-2 cursor-pointer  get-smm-proposal-button md:hidden rounded-5 border-purple text-18 text-purple px-23 mt-23 icon-paper-container transition-400">*/}
              {/*    <span className="icon icon-paper icon-paper2"/>*/}
              {/*    <span*/}
              {/*        className="block text-center text">Get Custom Proposal</span></a>*/}
              <div className={'cursor-pointer'}>
                <a
                  href={'/proposals/voice-proposal'}
                  className="flex items-center justify-center py-5 mt-20 text-center transition-all border  md:hidden rounded-5 border-green-badge text-18 text-green-badge px-23 hover:bg-green-badge hover:text-white icon-calculator-container transition-400"
                >
                  <svg width="15" height="23" viewBox="0 0 15 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_13026_9392)">
                      <path
                        d="M8.22446 0C8.70859 0.177107 9.22993 0.29051 9.67051 0.542165C11.156 1.39336 11.9042 2.71399 11.9179 4.41322C11.9383 7.03007 11.9315 9.64738 11.9206 12.2642C11.912 14.4089 10.563 16.1005 8.4722 16.6228C6.27113 17.1731 3.82369 15.7391 3.26197 13.5505C3.14958 13.1152 3.09032 12.668 3.08546 12.2186C3.06913 9.63156 3.06051 7.04453 3.08274 4.45795C3.09908 2.55812 3.98114 1.16837 5.70941 0.346534C6.04381 0.187047 6.42041 0.114758 6.7775 0.00225902L8.22446 0Z"
                        fill="currentColor"
                      />
                      <path
                        d="M6.80159 21.6234V19.789C6.44405 19.7208 6.09376 19.6743 5.75437 19.5853C2.99476 18.8619 1.18527 17.1288 0.306383 14.4324C0.0908588 13.7733 0.0110016 13.087 0.00011198 12.3939C-0.0062403 11.9846 0.258287 11.6805 0.63534 11.6557C1.03236 11.6294 1.31866 11.8852 1.37629 12.3085C1.45161 12.8633 1.47656 13.4326 1.62221 13.9693C2.07867 15.6464 3.1032 16.9119 4.64317 17.713C6.47445 18.6658 8.3638 18.7038 10.2168 17.7808C12.1166 16.8347 13.221 15.2741 13.555 13.1827C13.6058 12.8665 13.6003 12.5403 13.6457 12.2213C13.6675 12.0636 13.746 11.9192 13.8667 11.8148C13.9873 11.7104 14.142 11.6532 14.3018 11.6538C14.3944 11.6509 14.4865 11.6668 14.5727 11.7006C14.6588 11.7344 14.7372 11.7853 14.8029 11.8503C14.8686 11.9153 14.9203 11.9929 14.9548 12.0784C14.9894 12.164 15.006 12.2556 15.0037 12.3478C14.9915 13.5677 14.7224 14.727 14.1416 15.8028C13.1534 17.6317 11.657 18.8624 9.66647 19.4804C9.19594 19.6264 8.70228 19.6969 8.20363 19.8057V21.6066C8.28348 21.6121 8.36198 21.6225 8.44093 21.6225C9.16373 21.6225 9.88698 21.6225 10.6098 21.6256C10.7448 21.6225 10.8795 21.6409 11.0086 21.6803C11.3085 21.7837 11.4814 22.0996 11.4356 22.4181C11.4117 22.568 11.3384 22.7058 11.2273 22.8098C11.1162 22.9137 10.9735 22.978 10.8217 22.9923C10.7023 23.0041 10.5807 22.9986 10.4587 22.9986C8.41779 22.9986 6.37689 22.9986 4.336 22.9986C3.84642 22.9986 3.53924 22.7023 3.56465 22.2622C3.58597 21.8836 3.87909 21.6297 4.32375 21.6256C5.05426 21.6193 5.78477 21.6256 6.51528 21.6256L6.80159 21.6234Z"
                        fill="currentColor"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_13026_9392">
                        <rect width="15" height="23" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <span className={'ml-10'}>Send a Voice Message</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="">
          <div className="" id="multiservices-section">
            <style jsx global>{`
              .player-wrapper video:focus {
                outline: none;
              }
            `}</style>
          </div>
        </div>
        <style>{`
                            .part-margin-scroll{
                                scroll-margin-top: 100px;
                            }
                        `}</style>
        {/* facebook start */}
        <Platform
          width={this.props.width}
          h={475}
          show={this.state.showFb}
          scrollToPlatform={this.scrollToPlatform}
          id="facebook"
          ref={this.state.facebook}
        >
          <div className="bg-white">
            <LazyLoad height={400} once>
              <div className="relative pb-0 bg-white py-23 md:pb-23">
                <div className="container">
                  <div className="grid grid-cols-12">
                    <div className="col-span-6">
                      <p className="font-black leading-tight uppercase text-purple text-24 md:text-48 mb-23">
                        Facebook<br></br>marketing
                      </p>
                    </div>
                    <div className="col-span-1 md:col-span-2" />
                    <div className="col-span-5 md:col-span-4">
                      <div className="relative flex items-center mb-30">
                        <div className="z-10 realtive">
                          <Image src="/images/smm/fb.png" width="341" height="111" layout="intrinsic" alt="fb" />
                        </div>

                        <p className="absolute font-black fb-animation-text" style={{ fontSize: '54px', color: 'rgba(38, 38, 40, 0.04)' }}>
                          <span
                            className="inline-block"
                            style={{
                              animation: 'wave 1.4s ease-in-out infinite',
                              animationDelay: '0.0s',
                            }}
                          >
                            F
                          </span>
                          <span
                            className="inline-block"
                            style={{
                              animation: 'wave 1.4s ease-in-out infinite',
                              animationDelay: '0.1s',
                            }}
                          >
                            A
                          </span>
                          <span
                            className="inline-block"
                            style={{
                              animation: 'wave 1.4s ease-in-out infinite',
                              animationDelay: '0.2s',
                            }}
                          >
                            C
                          </span>
                          <span
                            className="inline-block"
                            style={{
                              animation: 'wave 1.4s ease-in-out infinite',
                              animationDelay: '0.3s',
                            }}
                          >
                            E
                          </span>
                          <span
                            className="inline-block"
                            style={{
                              animation: 'wave 1.4s ease-in-out infinite',
                              animationDelay: '0.4s',
                            }}
                          >
                            B
                          </span>
                          <span
                            className="inline-block"
                            style={{
                              animation: 'wave 1.4s ease-in-out infinite',
                              animationDelay: '0.5s',
                            }}
                          >
                            O
                          </span>
                          <span
                            className="inline-block"
                            style={{
                              animation: 'wave 1.4s ease-in-out infinite',
                              animationDelay: '0.6s',
                            }}
                          >
                            O
                          </span>
                          <span
                            className="inline-block"
                            style={{
                              animation: 'wave 1.4s ease-in-out infinite',
                              animationDelay: '0.7s',
                            }}
                          >
                            K
                          </span>
                        </p>

                        <style jsx>{``}</style>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col-reverse justify-between md:flex-row">
                    <div className="w-full mt-0 md:w-50p ">
                      <p className="hidden mb-10 font-bold md:block text-purple text-16 md:text-24 md:font-medium md:mb-30">Description</p>

                      <p className="hidden text-black text-16 md:block">
                        If you’re a brand wanting to prosper on social media, dominating Facebook marketing will be the key with 2.27 billion dynamic
                        users. Today, this social network can do things a large number of us couldn't even imagine a few years ago: have 360-degree
                        videos, create chatbots and sell items even better than sales consultants, connect with customers in real-time and answer
                        their inquiries.<br></br>
                        Similar to a personal profile, a Facebook business page is a public presence yet permits fans to “like” the business, brand,
                        or organization. The businesses can raise brand awareness, convey and track advertising, gather detailed audience insights,
                        communicate with clients, and assist users in their needs.<br></br>
                        When making a purchase decision, 75% of individuals use social media. A smart Facebook marketing strategy is the only way to
                        influence this process. Our Facebook Marketing Service is intended to fit your business needs and includes all solutions to
                        succeed on social media.
                      </p>
                      <div className="block md:hidden">
                        <ViewMore ln={20}>
                          If you’re a brand wanting to prosper on social media, dominating Facebook marketing will be the key with 2.27 billion
                          dynamic users. Today, this social network can do things a large number of us couldn't even imagine a few years ago: have
                          360-degree videos, create chatbots and sell items even better than sales consultants, connect with customers in real-time
                          and answer their inquiries.<br></br>
                          Similar to a personal profile, a Facebook business page is a public presence yet permits fans to “like” the business, brand,
                          or organization. The businesses can raise brand awareness, convey and track advertising, gather detailed audience insights,
                          communicate with clients, and assist users in their needs.<br></br>
                          When making a purchase decision, 75% of individuals use social media. A smart Facebook marketing strategy is the only way to
                          influence this process. Our Facebook Marketing Service is intended to fit your business needs and includes all solutions to
                          succeed on social media.
                        </ViewMore>
                      </div>
                    </div>
                    {/*<div className="order-2 hidden col-span-2 md:block"/>*/}
                    <div className="self-start hidden w-full px-0 py-0 mt-0 bg-transparent md:block md:w-40p max-w-380 md:bg-red-smm md:py-24 md:px-26 md:mt-5">
                      <h2 className={'hidden md:block text-16 md:text-24 leading-29 md:leading-29 tracking-001 text-black font-bolder'}>
                        Facebook Marketing
                      </h2>
                      <div className="flex items-start mt-0 font-normal md:mt-15 text-16 leading-20">
                        <img src="https://admin.weprodigi.com/uploads/images/smm/checkGreen.svg" alt="check" width={13} className={'mt-5'} />
                        <span className={'ml-15'}>10 posts creatives</span>
                      </div>
                      <div className="flex items-start mt-5 font-normal text-16 leading-20">
                        <img src="https://admin.weprodigi.com/uploads/images/smm/checkGreen.svg" alt="check" width={13} className={'mt-5'} />
                        <span className={'ml-15'}>7 custom-designed visuals(images)</span>
                      </div>
                      <div className="flex items-start mt-5 font-normal text-16 leading-20">
                        <img src="https://admin.weprodigi.com/uploads/images/smm/checkGreen.svg" alt="check" width={13} className={'mt-5'} />
                        <span className={'ml-15'}>3 custom videos </span>
                      </div>
                      <div className="flex items-start mt-5 font-normal text-16 leading-20">
                        <img src="https://admin.weprodigi.com/uploads/images/smm/checkGreen.svg" alt="check" width={13} className={'mt-5'} />
                        <span className={'ml-15'}>2 boosted posts</span>
                      </div>
                      <div
                        className="flex items-center pb-20 font-medium cursor-pointer mt-15 md:pb-0 text-green-badge text-20 leading-24"
                        onClick={() => {
                          this.hideAll();
                          this.setState({ showFb: true });
                          const that = this;
                          setTimeout(() => that.scrollTo(that.fbRef), 200);
                        }}
                      >
                        See Full Deliverables
                        <p className="jello-horizontal">
                          {' '}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-6 h-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth={2}
                          >
                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                          </svg>
                        </p>
                      </div>
                      <div className="relative flex items-center justify-center mt-23">
                        <button
                          onClick={() => this.showSMMCustomProposalWithoutPlatform('facebook')}
                          className={
                            'bg-green-badge hover:bg-green-hover inline-block  transition-all transition-400 text-white   px-23 py-5 text-16 rounded-md'
                          }
                        >
                          Get a Proposal
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <FacebookContent show={this.state.showFb} refProp={this.fbRef} />
            </LazyLoad>

            <SocialMediaProposal
              step={this.state.step}
              hide={this.state.hideSMMPricingModal}
              showSMMPricingModal={this.showSMMPricingModal}
              showProposal={this.showOfferModal}
              service="Facebook"
              image="/images/smm/proposal/fb.png"
            />
          </div>
        </Platform>
        {/* facebook end */}
        {/* instam start */}
        <Platform
          width={this.props.width}
          h={475}
          show={this.state.showInta}
          scrollToPlatform={this.scrollToPlatform}
          id="instagram"
          ref={this.state.instagram}
        >
          <div className="bg-liht-gray">
            <LazyLoad height={400} once>
              <div className="bg-liht-gray py-23">
                <div className="container">
                  <div className="grid grid-cols-12">
                    <div className="col-span-6">
                      <p className="font-black leading-tight uppercase text-purple text-24 md:text-48 mb-23">
                        Instagram<br></br>marketing
                      </p>
                    </div>
                    <div className="col-span-1 md:col-span-2" />
                    <div className="col-span-5 md:col-span-4">
                      <div className="relative flex items-center mb-30">
                        <div className="z-10 realtive">
                          <Image src="/images/smm/insta.png" width="352" height="111" layout="intrinsic" alt="instagram" />
                        </div>
                        <p className="absolute font-black insta-animation-text" style={{ fontSize: '54px', color: 'rgba(38, 38, 40, 0.04)' }}>
                          <span
                            className="inline-block"
                            style={{
                              animation: 'wave 1.4s ease-in-out infinite',
                              animationDelay: '0.0s',
                            }}
                          >
                            I
                          </span>
                          <span
                            className="inline-block"
                            style={{
                              animation: 'wave 1.4s ease-in-out infinite',
                              animationDelay: '0.1s',
                            }}
                          >
                            N
                          </span>
                          <span
                            className="inline-block"
                            style={{
                              animation: 'wave 1.4s ease-in-out infinite',
                              animationDelay: '0.2s',
                            }}
                          >
                            S
                          </span>
                          <span
                            className="inline-block"
                            style={{
                              animation: 'wave 1.4s ease-in-out infinite',
                              animationDelay: '0.3s',
                            }}
                          >
                            T
                          </span>
                          <span
                            className="inline-block"
                            style={{
                              animation: 'wave 1.4s ease-in-out infinite',
                              animationDelay: '0.4s',
                            }}
                          >
                            A
                          </span>
                          <span
                            className="inline-block"
                            style={{
                              animation: 'wave 1.4s ease-in-out infinite',
                              animationDelay: '0.5s',
                            }}
                          >
                            G
                          </span>
                          <span
                            className="inline-block"
                            style={{
                              animation: 'wave 1.4s ease-in-out infinite',
                              animationDelay: '0.6s',
                            }}
                          >
                            R
                          </span>
                          <span
                            className="inline-block"
                            style={{
                              animation: 'wave 1.4s ease-in-out infinite',
                              animationDelay: '0.7s',
                            }}
                          >
                            A
                          </span>
                          <span
                            className="inline-block"
                            style={{
                              animation: 'wave 1.4s ease-in-out infinite',
                              animationDelay: '0.8s',
                            }}
                          >
                            M
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col-reverse justify-between md:flex-row">
                    <div className="w-full mt-0 md:w-50p">
                      <p className="hidden font-bold md:block text-purple text-16 md:text-24 md:font-medium mb-15 md:mb-30">Description</p>
                      <p className="hidden text-black md:block text-16">
                        Indeed, all businesses should have a public presence on Instagram, however there are industries for which this is an absolute
                        necessity: HoReCa, clothing and accessories, beauty products and services, Health and sports.<br></br>
                        In terms of its capabilities, Instagram now and again outperforms other social media platforms. Here, in addition to beautiful
                        visual content, users are provided with interactive stories, camera filters, videos of industry influencers, reels with
                        helpful tips, interesting giveaways, etc. All this creates additional value for the user and further contributes to increased
                        engagement with the brand.<br></br>
                        We will create content that will help capture the desired outcomes, create a competitive advantage and capture users'
                        attention. All this is possible because WeProdigi, unlike many other digital agencies, has a separate creative and production
                        department that specializes in creating unique and effective visual assets.
                      </p>
                      <div className="block text-black md:hidden text-16">
                        <ViewMore ln={20}>
                          Indeed, all businesses should have a public presence on Instagram, however there are industries for which this is an
                          absolute necessity: HoReCa, clothing and accessories, beauty products and services, Health and sports.<br></br>
                          In terms of its capabilities, Instagram now and again outperforms other social media platforms. Here, in addition to
                          beautiful visual content, users are provided with interactive stories, camera filters, videos of industry influencers, reels
                          with helpful tips, interesting giveaways, etc. All this creates additional value for the user and further contributes to
                          increased engagement with the brand.<br></br>
                          We will create content that will help capture the desired outcomes, create a competitive advantage and capture users'
                          attention. All this is possible because WeProdigi, unlike many other digital agencies, has a separate creative and
                          production department that specializes in creating unique and effective visual assets.
                        </ViewMore>
                      </div>
                    </div>

                    <div className="hidden col-span-2 md:block" />

                    <div className="self-start hidden w-full px-0 py-0 mt-0 bg-transparent md:block md:w-40p max-w-380 md:bg-red-smm md:py-24 md:px-26 md:mt-5">
                      <h2 className={'hidden md:block  text-16 md:text-24 leading-29 md:leading-29 tracking-001 text-black font-bolder'}>
                        Instagram Marketing
                      </h2>
                      <div className="flex items-start mt-0 font-normal md:mt-15 text-16 leading-20">
                        <img src="https://admin.weprodigi.com/uploads/images/smm/checkGreen.svg" alt="check" width={13} className={'mt-5'} />
                        <span className={'ml-15'}>12 posts creatives</span>
                      </div>
                      <div className="flex items-start mt-5 font-normal text-16 leading-20">
                        <img src="https://admin.weprodigi.com/uploads/images/smm/checkGreen.svg" alt="check" width={13} className={'mt-5'} />
                        <span className={'ml-15'}>8 custom-designed visuals(images)</span>
                      </div>
                      <div className="flex items-start mt-5 font-normal text-16 leading-20">
                        <img src="https://admin.weprodigi.com/uploads/images/smm/checkGreen.svg" alt="check" width={13} className={'mt-5'} />
                        <span className={'ml-15'}>4 reels </span>
                      </div>
                      <div className="flex items-start mt-5 font-normal text-16 leading-20">
                        <img src="https://admin.weprodigi.com/uploads/images/smm/checkGreen.svg" alt="check" width={13} className={'mt-5'} />
                        <span className={'ml-15'}>2 boosted posts</span>
                      </div>
                      <div
                        className="flex items-center pb-20 font-medium cursor-pointer mt-15 md:pb-0 text-green-badge text-20 leading-24"
                        onClick={() => {
                          this.hideAll();
                          this.setState({ showInta: true });
                          const that = this;
                          setTimeout(() => that.scrollTo(that.instaRef), 200);
                        }}
                      >
                        See Full Deliverables
                        <p className="jello-horizontal">
                          {' '}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-6 h-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth={2}
                          >
                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                          </svg>
                        </p>
                      </div>

                      <div className="flex items-center justify-center mt-23">
                        <button
                          onClick={() => this.showSMMCustomProposalWithoutPlatform('instagram')}
                          className={
                            'bg-green-badge hover:bg-green-hover inline-block  transition-all transition-400 text-white   px-23 py-5 text-16 rounded-md'
                          }
                        >
                          Get a Proposal
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <InstagramContent refProp={this.instaRef} />
            </LazyLoad>
            <SocialMediaProposal showProposal={this.showOfferModal} service="Instagram" image="/images/smm/proposal/insta.png" />
          </div>
        </Platform>
        {/* instagram end */}
        {/* Linkedin start */}
        <Platform
          width={this.props.width}
          h={475}
          show={this.state.showLinkedIn}
          scrollToPlatform={this.scrollToPlatform}
          id="linkedin"
          ref={this.state.linkedin}
        >
          <div className="bg-white">
            <LazyLoad height={400} once>
              <div className="bg-white py-23">
                <div className="container">
                  <div className="grid grid-cols-12">
                    <div className="col-span-6">
                      <p className="font-black leading-tight uppercase text-purple text-24 md:text-48 mb-23">
                        LinkedIn<br></br>marketing
                      </p>
                    </div>
                    <div className="col-span-1 md:col-span-2" />
                    <div className="col-span-5 md:col-span-4">
                      <div className="relative flex items-center mb-30">
                        <div className="z-10 realtive">
                          <Image src="/images/smm/linkedin.png" width="352" height="111" layout="intrinsic" alt="linkedin" />
                        </div>
                        <p className="absolute font-black linkedin-animation-text" style={{ fontSize: '67px', color: 'rgba(38, 38, 40, 0.04)' }}>
                          <span
                            className="inline-block"
                            style={{
                              animation: 'wave 1.4s ease-in-out infinite',
                              animationDelay: '0.0s',
                            }}
                          >
                            L
                          </span>
                          <span
                            className="inline-block"
                            style={{
                              animation: 'wave 1.4s ease-in-out infinite',
                              animationDelay: '0.1s',
                            }}
                          >
                            I
                          </span>
                          <span
                            className="inline-block"
                            style={{
                              animation: 'wave 1.4s ease-in-out infinite',
                              animationDelay: '0.2s',
                            }}
                          >
                            N
                          </span>
                          <span
                            className="inline-block"
                            style={{
                              animation: 'wave 1.4s ease-in-out infinite',
                              animationDelay: '0.3s',
                            }}
                          >
                            K
                          </span>
                          <span
                            className="inline-block"
                            style={{
                              animation: 'wave 1.4s ease-in-out infinite',
                              animationDelay: '0.4s',
                            }}
                          >
                            E
                          </span>
                          <span
                            className="inline-block"
                            style={{
                              animation: 'wave 1.4s ease-in-out infinite',
                              animationDelay: '0.5s',
                            }}
                          >
                            D
                          </span>
                          <span
                            className="inline-block"
                            style={{
                              animation: 'wave 1.4s ease-in-out infinite',
                              animationDelay: '0.6s',
                            }}
                          >
                            I
                          </span>
                          <span
                            className="inline-block"
                            style={{
                              animation: 'wave 1.4s ease-in-out infinite',
                              animationDelay: '0.7s',
                            }}
                          >
                            N
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="flex flex-col-reverse justify-between md:flex-row ">
                    <div className="w-full mt-0 md:w-50p">
                      <p className="hidden font-bold md:block text-purple text-16 md:text-24 md:font-medium mb-15 md:mb-30">Description</p>

                      <p className="hidden text-black md:block text-16">
                        LinkedIn is the number one B2B platform where, with the help of marketing, you can reach the representatives of targeted
                        organizations. It is effective for B2B as well since the user is not only an employee of an X company but is also a consumer
                        of thousands of other products and services. Unlike other social networks, LinkedIn users are more mature, analytical, and
                        serious about any information they receive. Taking this into consideration, LinkedIn has the benefit of providing specific
                        information that is difficult for others to assimilate. Moreover, it is the most effective platform for demonstrating
                        corporate culture, positioning yourself as a good employer, or finding new employees. As a B2B company with over 100 B2C
                        customers, we do know how to do LinkedIn marketing to get the most out of it. This may be evidenced{' '}
                        <a href="https://www.linkedin.com/company/11301888/admin/" target="_blank">
                          by the page of our company.
                        </a>
                      </p>
                      <div className="block text-black md:hidden text-16">
                        <ViewMore ln={25}>
                          LinkedIn is the number one B2B platform where, with the help of marketing, you can reach the representatives of targeted
                          organizations. It is effective for B2B as well since the user is not only an employee of an X company but is also a consumer
                          of thousands of other products and services. Unlike other social networks, LinkedIn users are more mature, analytical, and
                          serious about any information they receive. Taking this into consideration, LinkedIn has the benefit of providing specific
                          information that is difficult for others to assimilate. Moreover, it is the most effective platform for demonstrating
                          corporate culture, positioning yourself as a good employer, or finding new employees. As a B2B company with over 100 B2C
                          customers, we do know how to do LinkedIn marketing to get the most out of it. This may be evidenced{' '}
                          <a href="https://www.linkedin.com/company/11301888/admin/" target="_blank">
                            by the page of our company.
                          </a>
                        </ViewMore>
                      </div>
                    </div>

                    <div className="hidden col-span-2 md:block" />

                    <div className="self-start hidden w-full px-0 py-0 mt-0 bg-transparent md:block md:w-40p max-w-380 md:bg-red-smm md:py-24 md:px-26 md:mt-5">
                      <h2 className={'hidden md:block text-16 md:text-24 leading-29 md:leading-29 tracking-001 text-black font-bolder'}>
                        Linkedin Marketing
                      </h2>
                      <div className="flex items-start mt-0 font-normal md:mt-15 text-16 leading-20">
                        <img src="https://admin.weprodigi.com/uploads/images/smm/checkGreen.svg" alt="check" width={13} className={'mt-5'} />
                        <span className={'ml-15'}>6 custom-designed posts</span>
                      </div>
                      <div className="flex items-start mt-5 font-normal text-16 leading-20">
                        <img src="https://admin.weprodigi.com/uploads/images/smm/checkGreen.svg" alt="check" width={13} className={'mt-5'} />
                        <span className={'ml-15'}>2 Linkedin polls</span>
                      </div>
                      <div className="flex items-start mt-5 font-normal text-16 leading-20">
                        <img src="https://admin.weprodigi.com/uploads/images/smm/checkGreen.svg" alt="check" width={13} className={'mt-5'} />
                        <span className={'ml-15'}>3 custom videos </span>
                      </div>
                      <div className="flex items-start mt-5 font-normal text-16 leading-20">
                        <img src="https://admin.weprodigi.com/uploads/images/smm/checkGreen.svg" alt="check" width={13} className={'mt-5'} />
                        <span className={'ml-15'}>2 boosted posts</span>
                      </div>
                      <div
                        className="flex items-center pb-20 font-medium cursor-pointer mt-15 md:pb-0 text-green-badge text-20 leading-24"
                        onClick={() => {
                          this.hideAll();
                          this.setState({ showLinkedIn: true });
                          const that = this;
                          setTimeout(() => that.scrollTo(that.linkedInRef), 200);
                        }}
                      >
                        See Full Deliverables
                        <p className="jello-horizontal">
                          {' '}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-6 h-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth={2}
                          >
                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                          </svg>
                        </p>
                      </div>

                      <div className="flex items-center justify-center mt-23">
                        <button
                          onClick={() => this.showSMMCustomProposalWithoutPlatform('linkedin')}
                          className={
                            'bg-green-badge hover:bg-green-hover inline-block  transition-all transition-400 text-white   px-23 py-5 text-16 rounded-md'
                          }
                        >
                          Get a Proposal
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <LinkedinContent refProp={this.linkedInRef} />
            </LazyLoad>

            <SocialMediaProposal showProposal={this.showOfferModal} service="LinkedIn" image="/images/smm/proposal/linkedin.png" />
          </div>
        </Platform>
        {/*/!* linkedin end *!/*/}
        {/*/!* snapchat start *!/*/}
        <Platform
          width={this.props.width}
          h={475}
          show={this.state.showSnapchat}
          scrollToPlatform={this.scrollToPlatform}
          id="snapchat"
          ref={this.state.snapchat}
        >
          <LazyLoad height={400} once>
            <div className="bg-liht-gray py-23">
              <div className="container">
                <div className="grid grid-cols-12">
                  <div className="col-span-6">
                    <p className="font-black leading-tight uppercase text-purple text-24 md:text-48 mb-23">
                      Snapchat<br></br>marketing
                    </p>
                  </div>

                  <div className="col-span-1 md:col-span-2" />
                  <div className="col-span-5 md:col-span-4">
                    <div className="relative flex items-center mb-30">
                      <div className="z-10 realtive">
                        <Image src="/images/smm/snapchat.png" width="360" height="98" layout="intrinsic" alt="snapchat" />
                      </div>
                      <p className="absolute font-black snapchat-animation-text" style={{ fontSize: '59px', color: 'rgba(38, 38, 40, 0.04)' }}>
                        <span
                          className="inline-block"
                          style={{
                            animation: 'wave 1.4s ease-in-out infinite',
                            animationDelay: '0.0s',
                          }}
                        >
                          S
                        </span>
                        <span
                          className="inline-block"
                          style={{
                            animation: 'wave 1.4s ease-in-out infinite',
                            animationDelay: '0.1s',
                          }}
                        >
                          N
                        </span>
                        <span
                          className="inline-block"
                          style={{
                            animation: 'wave 1.4s ease-in-out infinite',
                            animationDelay: '0.2s',
                          }}
                        >
                          A
                        </span>
                        <span
                          className="inline-block"
                          style={{
                            animation: 'wave 1.4s ease-in-out infinite',
                            animationDelay: '0.3s',
                          }}
                        >
                          P
                        </span>
                        <span
                          className="inline-block"
                          style={{
                            animation: 'wave 1.4s ease-in-out infinite',
                            animationDelay: '0.4s',
                          }}
                        >
                          C
                        </span>
                        <span
                          className="inline-block"
                          style={{
                            animation: 'wave 1.4s ease-in-out infinite',
                            animationDelay: '0.5s',
                          }}
                        >
                          H
                        </span>
                        <span
                          className="inline-block"
                          style={{
                            animation: 'wave 1.4s ease-in-out infinite',
                            animationDelay: '0.6s',
                          }}
                        >
                          A
                        </span>
                        <span
                          className="inline-block"
                          style={{
                            animation: 'wave 1.4s ease-in-out infinite',
                            animationDelay: '0.7s',
                          }}
                        >
                          T
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col-reverse justify-between md:flex-row">
                  <div className="w-full mt-0 md:w-50p">
                    <p className="hidden font-bold md:block text-purple text-16 md:text-24 md:font-medium mb-15 md:mb-30">Description</p>
                    <p className="hidden text-black md:block text-16">
                      Want your brand to become popular among Gen Z? Develop your Snapchat account, as it’s main audience is a younger demographic,
                      and Snapchat can be a potent source of engagement.
                      <br />
                      If your business wants to connect with people under the age of 35, Snapchat is the right place to be. It is a great opportunity
                      for brands to target new audiences (more than one third of Snapchat users can’t be found on Instagram or Facebook) and increase
                      brand’s social media presence.
                      <br />
                      Unlike other social media platforms, Snapchat connects the brand with users in its geographic area and helps users recognize
                      your brand. Businesses are using Snapchat for brands in order to promote their products and services by producing original
                      content for the platform.
                      <br />
                      Our Snapchat Marketing Service is intended to make the most of this platform for marketing your business and find the right
                      audience for you, by presenting the brand with dynamic visuals, making it easy to stand out in the crowd. Our experts are
                      specialized in introducing features designed specifically to serve the brand’s needs, including goal-based bidding options,
                      enhanced audience targeting, optimized geofilters and many more. We deliver those results by not only launching strong
                      campaigns, but actively monitoring them to identify which strategies are most effective, closely tracking, measuring, and
                      reporting essential campaign data.
                    </p>

                    <div className="block text-black md:hidden text-16">
                      <ViewMore ln={25}>
                        Want your brand to become popular among Gen Z? Develop your Snapchat account, as it’s main audience is a younger demographic,
                        and Snapchat can be a potent source of engagement.
                        <br />
                        If your business wants to connect with people under the age of 35, Snapchat is the right place to be. It is a great
                        opportunity for brands to target new audiences (more than one third of Snapchat users can’t be found on Instagram or Facebook)
                        and increase brand’s social media presence.
                        <br />
                        Unlike other social media platforms, Snapchat connects the brand with users in its geographic area and helps users recognize
                        your brand. Businesses are using Snapchat for brands in order to promote their products and services by producing original
                        content for the platform.
                        <br />
                        Our Snapchat Marketing Service is intended to make the most of this platform for marketing your business and find the right
                        audience for you, by presenting the brand with dynamic visuals, making it easy to stand out in the crowd. Our experts are
                        specialized in introducing features designed specifically to serve the brand’s needs, including goal-based bidding options,
                        enhanced audience targeting, optimized geofilters and many more. We deliver those results by not only launching strong
                        campaigns, but actively monitoring them to identify which strategies are most effective, closely tracking, measuring, and
                        reporting essential campaign data.
                      </ViewMore>
                    </div>
                  </div>
                  <div className="hidden col-span-2 md:block" />
                  <div className="self-start hidden w-full px-0 py-0 mt-0 bg-transparent md:block md:w-40p max-w-380 md:bg-red-smm md:py-24 md:px-26 md:mt-5">
                    <h2 className={'hidden md:block text-16 md:text-24 leading-29 md:leading-29 tracking-001 text-black font-bolder'}>
                      Snapchat Marketing
                    </h2>
                    <div className="flex items-start mt-0 font-normal md:mt-15 text-16 leading-20">
                      <img src="https://admin.weprodigi.com/uploads/images/smm/checkGreen.svg" alt="check" width={13} className={'mt-5'} />
                      <span className={'ml-15'}>10 content creatives</span>
                    </div>
                    <div className="flex items-start mt-5 font-normal text-16 leading-20">
                      <img src="https://admin.weprodigi.com/uploads/images/smm/checkGreen.svg" alt="check" width={13} className={'mt-5'} />
                      <span className={'ml-15'}>6 Snapchat posts</span>
                    </div>
                    <div className="flex items-start mt-5 font-normal text-16 leading-20">
                      <img src="https://admin.weprodigi.com/uploads/images/smm/checkGreen.svg" alt="check" width={13} className={'mt-5'} />
                      <span className={'ml-15'}>2 Snapchat custom videos</span>
                    </div>
                    <div className="flex items-start mt-5 font-normal text-16 leading-20">
                      <img src="https://admin.weprodigi.com/uploads/images/smm/checkGreen.svg" alt="check" width={13} className={'mt-5'} />
                      <span className={'ml-15'}>2 boosted posts</span>
                    </div>
                    <div
                      className="flex items-center pb-20 font-medium cursor-pointer mt-15 md:pb-0 text-green-badge text-20 leading-24"
                      onClick={() => {
                        this.hideAll();
                        this.setState({ showSnapchat: true });
                        const that = this;
                        setTimeout(() => that.scrollTo(that.snapchatRef), 200);
                      }}
                    >
                      See Full Deliverables
                      <p className="jello-horizontal">
                        {' '}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="w-6 h-6"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          strokeWidth={2}
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                        </svg>{' '}
                      </p>
                    </div>

                    <div className="flex items-center justify-center mt-23">
                      <button
                        onClick={() => this.showSMMCustomProposalWithoutPlatform('snapchat')}
                        className={
                          'bg-green-badge hover:bg-green-hover inline-block  transition-all transition-400 text-white   px-23 py-5 text-16 rounded-md'
                        }
                      >
                        Get a Proposal
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <SnapchatContent refProp={this.snapchatRef} />
          </LazyLoad>
          <SocialMediaProposal showProposal={this.showOfferModal} service="Snapchat" image="/images/smm/proposal/snapchat.png" />
        </Platform>
        {/*/!* snapchat end *!/*/}
        {/*/!* Twitter start *!/*/}
        <Platform width={this.props.width} h={475} show={this.state.showX} scrollToPlatform={this.scrollToPlatform} id="x" ref={this.state.x}>
          <div className="bg-white">
            <LazyLoad height={400} once>
              <div className=" py-23">
                <div className="container">
                  <div className="grid grid-cols-12">
                    <div className="col-span-6">
                      <p className="font-black leading-tight uppercase text-purple text-24 md:text-48 mb-23">
                        X<br></br>marketing
                      </p>
                    </div>
                    <div className="col-span-1 md:col-span-2" />
                    <div className="col-span-5 md:col-span-4">
                      <div className="relative flex items-center mb-30">
                        <div className="z-10 realtive">
                          <Image src="/images/smm/twitter.png" width="360" height="98" layout="intrinsic" alt="x" />
                        </div>
                        <p className="absolute font-black x-animation-text" style={{ fontSize: '71px', color: 'rgba(38, 38, 40, 0.04)' }}>
                          <span
                            className="inline-block"
                            style={{
                              animation: 'wave 1.4s ease-in-out infinite',
                              animationDelay: '0.0s',
                            }}
                          >
                            T
                          </span>
                          <span
                            className="inline-block"
                            style={{
                              animation: 'wave 1.4s ease-in-out infinite',
                              animationDelay: '0.1s',
                            }}
                          >
                            W
                          </span>
                          <span
                            className="inline-block"
                            style={{
                              animation: 'wave 1.4s ease-in-out infinite',
                              animationDelay: '0.2s',
                            }}
                          >
                            I
                          </span>
                          <span
                            className="inline-block"
                            style={{
                              animation: 'wave 1.4s ease-in-out infinite',
                              animationDelay: '0.3s',
                            }}
                          >
                            T
                          </span>
                          <span
                            className="inline-block"
                            style={{
                              animation: 'wave 1.4s ease-in-out infinite',
                              animationDelay: '0.4s',
                            }}
                          >
                            T
                          </span>
                          <span
                            className="inline-block"
                            style={{
                              animation: 'wave 1.4s ease-in-out infinite',
                              animationDelay: '0.5s',
                            }}
                          >
                            E
                          </span>
                          <span
                            className="inline-block"
                            style={{
                              animation: 'wave 1.4s ease-in-out infinite',
                              animationDelay: '0.6s',
                            }}
                          >
                            R
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col-reverse justify-between md:flex-row">
                    <div className="w-full md:w-50p mt-25 md:mt-0">
                      <p className="hidden font-bold md:block text-purple text-16 md:text-24 md:font-medium mb-15 md:mb-30">Description</p>
                      <p className="hidden text-black md:block text-16">
                        If you are looking for different content and want your business to catch up with all the trends and challenges of the digital
                        world, X is the most suitable platform for you. <br></br>
                        Here users are more free, engaging in various challenges and they anticipate brands to be more free and share more interactive
                        content. Alongside its lightness and interactiveness, X has all the required tools for running sales driven marketing:
                        specific audience targeting tools, content sharing which boost website stream, advanced analytics, integration with CRMs.{' '}
                        <br></br>
                        In X the number of symbols is limited to save users time which directly reflect the essence of our motto “We value your time”.
                        Being a company which values customers time the highest, we know how to provide required content in a brief simple way, which
                        will still be catchy and interactive.
                      </p>
                      <div className="block text-black md:hidden text-16">
                        <ViewMore ln={20}>
                          If you are looking for different content and want your business to catch up with all the trends and challenges of the
                          digital world, X is the most suitable platform for you. <br></br>
                          Here users are more free, engaging in various challenges and they anticipate brands to be more free and share more
                          interactive content. Alongside its lightness and interactiveness, X has all the required tools for running sales driven
                          marketing: specific audience targeting tools, content sharing which boost website stream, advanced analytics, integration
                          with CRMs. <br></br>
                          In X the number of symbols is limited to save users time which directly reflect the essence of our motto “We value your
                          time”. Being a company which values customers time the highest, we know how to provide required content in a brief simple
                          way, which will still be catchy and interactive.
                        </ViewMore>
                      </div>
                    </div>
                    <div className="hidden col-span-2 md:block" />
                    <div className="self-start hidden w-full px-0 py-0 mt-0 bg-transparent md:block md:w-40p max-w-380 md:bg-red-smm md:py-24 md:px-26 md:mt-5">
                      <h2 className={'hidden md:block text-16 md:text-24 leading-29 md:leading-29 tracking-001 text-black font-bolder'}>
                        X Marketing
                      </h2>
                      <div className="flex items-start mt-0 font-normal md:mt-15 text-16 leading-20">
                        <img src="https://admin.weprodigi.com/uploads/images/smm/checkGreen.svg" alt="check" width={13} className={'mt-5'} />
                        <span className={'ml-15'}>10 content creatives</span>
                      </div>
                      <div className="flex items-start mt-5 font-normal text-16 leading-20">
                        <img src="https://admin.weprodigi.com/uploads/images/smm/checkGreen.svg" alt="check" width={13} className={'mt-5'} />
                        <span className={'ml-15'}>8 tweets</span>
                      </div>
                      <div className="flex items-start mt-5 font-normal text-16 leading-20">
                        <img src="https://admin.weprodigi.com/uploads/images/smm/checkGreen.svg" alt="check" width={13} className={'mt-5'} />
                        <span className={'ml-15'}>2 custom videos </span>
                      </div>
                      <div className="flex items-start mt-5 font-normal text-16 leading-20">
                        <img src="https://admin.weprodigi.com/uploads/images/smm/checkGreen.svg" alt="check" width={13} className={'mt-5'} />
                        <span className={'ml-15'}>2 boosted posts</span>
                      </div>
                      <div
                        className="flex items-center pb-20 font-medium cursor-pointer mt-15 md:pb-0 text-green-badge text-20 leading-24"
                        onClick={() => {
                          this.hideAll();
                          this.setState({ showX: true });
                          const that = this;
                          setTimeout(() => that.scrollTo(that.xRef), 200);
                        }}
                      >
                        See Full Deliverables
                        <p className="jello-horizontal">
                          {' '}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-6 h-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth={2}
                          >
                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                          </svg>{' '}
                        </p>
                      </div>

                      <div className="flex items-center justify-center mt-23">
                        <button
                          onClick={() => this.showSMMCustomProposalWithoutPlatform('x')}
                          className={
                            'bg-green-badge hover:bg-green-hover inline-block  transition-all transition-400 text-white   px-23 py-5 text-16 rounded-md'
                          }
                        >
                          Get a Proposal
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <XContent refProp={this.xRef} />
            </LazyLoad>
            <SocialMediaProposal showProposal={this.showOfferModal} service="X" image="/images/smm/proposal/twitter.png" />
          </div>
        </Platform>
        {/* /!* x end *!/*/}
        {/*/!*</LazyLoad>*!/*/}

        {/*<LazyLoad>*/}
        {/*    <div className="bg-gray py-23 md:py-50">*/}
        {/*        <div className="container">*/}
        {/*            <p className="font-black leading-none uppercase text-purple text-24 md:text-36">SMM PRICING*/}
        {/*                Calculator</p>*/}
        {/*            <Calculator showProposal={this.showSMMPricing}/>*/}
        {/*        </div>*/}
        {/*    </div>*/}
        {/*</LazyLoad>*/}
        <div className="bg-gray-light py-23 md:py-50">
          <div className="container">
            <p className="font-black uppercase text-purple text-24 md:text-36 mb-23">How do our SMM services work</p>
            <ProcessSlider />
          </div>
        </div>
        <LazyLoad height={200} once>
          <div className="bg-white py-23 md:py-50">
            <div className="container">
              <p className="font-black uppercase text-purple text-24 md:text-36 mb-23">Our Work Speaks for Itself</p>
              <Work
                works={[
                  {
                    title: 'Audi',
                    category: 'Cars & Transportation',
                    link: 'https://weprodigi.com/main/case/27',
                    image: '/images/smm/works/1.png',
                  },
                  {
                    title: 'Desert Teleheart',
                    category: 'Healthcare',
                    link: 'https://weprodigi.com/main/case/67',
                    image: '/images/smm/works/2.png',
                  },
                  {
                    title: 'Mavroki Perfume',
                    category: 'Beauty & Fashion',
                    link: 'https://weprodigi.com/main/case/68',
                    image: '/images/smm/works/3.png',
                  },
                  {
                    title: 'Vohco Lingerie',
                    category: 'Ecommerce',
                    link: 'https://weprodigi.com/main/case/15',
                    image: '/images/smm/works/4.png',
                  },
                  {
                    title: 'Cornwall Laser Clinic',
                    category: 'Healthcare',
                    link: 'https://weprodigi.com/main/case/26',
                    image: '/images/smm/works/5.png',
                  },
                ]}
              />
              <div className="mt-23">
                <div className="grid-cols-2 md:grid gap-15">
                  <div className="grid-cols-2 md:grid gap-15">
                    <div></div>
                    <a
                      className="inline-block w-full text-center capitalize transition-all bg-transparent border rounded-md md:bg-purple md:hover:bg-green transition-400 text-purple md:text-white px-15 py-7 text-16 md:border-0 border-purple mr-15"
                      href="https://weprodigi.com/main/cases"
                    >
                      see more from our clients
                    </a>
                  </div>
                  <div className="grid-cols-2 md:grid gap-15 mt-15 md:mt-0">
                    <button
                      onClick={this.showOfferModal2}
                      className="inline-block w-full text-center capitalize transition-all bg-transparent border rounded-md cursor-pointer md:bg-green md:hover:bg-purple transition-400 text-green md:text-white px-15 py-7 text-16 md:border-0 border-green"
                    >
                      Contact Us
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-gray-light py-23 md:py-50">
            <div className="container">
              <p className="font-black uppercase text-purple text-24 md:text-36 mb-23">
                Reviews:<br></br>Explore working with us
              </p>
              <div className="grid-cols-2 md:grid gap-30">
                <div>
                  <div className="w-full h-full bg-gray-slider">
                    <video poster="/images/about/thumbnail.jpg" src="/images/about/Locationdoesntmatter2.mp4" controls />
                  </div>
                </div>
                <div>
                  <p className="mt-10 text-16 color-black md:mt-0">
                    Our partners will be happy to personally confirm the review written by them and answer the questions you are interested in. Being
                    an international organization, we give you the opportunity to get to know the experience of our previous clients from your
                    country.<span className="block pb-15"></span>
                    Start exploring WeProdigi reviews now!<span className="block pb-15"></span>
                    Check out our reviews and find out why clients choose to experience digital with us.
                  </p>
                  <div className="flex justify-center md:justify-end mt-15">
                    <div className="flex flex-row">
                      <a
                        href="https://g.page/prodigi-agency/"
                        target="_blank"
                        className="flex leading-none text-center text-white capitalize transition-all rounded-md bg-green md:hover:bg-purple transition-400 px-15 py-7 text-16"
                      >
                        <Image src="/images/icons/smm/google-contact.svg" width="60" height="20" layout="fixed" alt="google-contect" />
                      </a>
                      <a
                        href="https://clutch.co/profile/weprodigi-agency"
                        target="_blank"
                        className="flex leading-none text-center text-white capitalize transition-all rounded-md bg-green md:hover:bg-purple transition-400 px-15 py-7 text-16 mx-15"
                      >
                        <Image src="/images/icons/social/clutch.svg" width="60" height="16" layout="fixed" alt="clutch" />
                      </a>
                      <a
                        href="https://www.facebook.com/weprodigi/reviews/"
                        target="_blank"
                        className="flex leading-none text-center text-white capitalize transition-all rounded-md bg-green md:hover:bg-purple transition-400 px-15 py-7 text-16"
                      >
                        <Image src="/images/icons/smm/facebook-contact.svg" width="76" height="15" layout="fixed" alt="facebook" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white">
            <div className="container py-23">
              <p className="font-black leading-none uppercase text-24 md:text-36 mb-23 text-purple">FAQ</p>
              <div className="grid md:grid-cols-2 md:gap-30">
                <Faq
                  content={[
                    {
                      title: 'Do you guarantee sales?',
                      answer:
                        "Nobody can ensure sales for your business, because professional SMM services are intended to help businesses succeed on Social Media and this indirectly impacts on generating sales. Furthermore, as an experienced agency, we can guarantee traffic to your website, brand awareness, and engagement, but we can't guarantee increased sales. We'll use our industry expertise to manage your social media efforts, but it's ultimately up to you to satisfy your target audience and encourage sales.",
                    },
                    {
                      title: 'Can I pre-approve the posts before they go live?',
                      answer:
                        'We will send you fortnightly content to approve and request amends before it’s due to go live the week after. That way, you can always see what we have lined up, make any changes, or request design modifications beforehand. ',
                    },
                    {
                      title: 'How do you get information about-us-new my target?',
                      answer:
                        'At the very beginning of the cooperation, we send a questionnaire, where the client fills in information about-us-new the business and the target audience. In addition, we use analytic tools that permit us to accumulate information about-us-new the target audience and build future activities dependent on it. This is all about-us-new personalized service.',
                    },
                    {
                      title: "What if my business doesn't have Social Media accounts?",
                      answer:
                        'In case of cooperation with us, we create and set up social media pages free of any charges, and you will have complete ownership of those accounts as well.',
                    },
                    {
                      title: 'What days of the week will you post on?',
                      answer:
                        'Although we create your posts and design your content calendar during the working week, they will be scheduled to go live on the days we agree. We will consistently look at your social media insights on each platform to see when your followers are most active to recommend optimum days and times to post.',
                    },
                  ]}
                />
                <Faq
                  content={[
                    {
                      title: 'How long does it take to have the first social media post published?',
                      answer: (
                        <>
                          On average, our usual preparation process requires from five to seven business days. But if you have a set deadline, we
                          always try to offer custom solutions without any extra fees.<br></br>During this period, our specialists do research and
                          collect information about your business, based on which the content is created and presented to you.
                        </>
                      ),
                    },
                    {
                      title: 'How much involvement will I have?',
                      answer:
                        'It is totally up to you. We have created a management process where everything is done to save your time. Simultaneously, you can be integrated into every process of our cooperation and hold discussions and brainstorming with us.',
                    },
                    {
                      title: 'What about payment?',
                      answer:
                        'Billing is carried out in 2 milestones: the first one after the first week of collaboration, and the other part at the end of the month. Kindly note that the research part is not included in the first working week, hence,  the one-month period starts from the day we send you the content of the first week.',
                    },
                    {
                      title: 'Do I have benefits if I order SMM services on more than 1 platform?',
                      answer:
                        'Yes. You do not have to pay the same price for each platform separately as we create a package that includes full service on the platforms of your choice, and you pay less for each platform that will be added as well.',
                    },
                    {
                      title: 'Can I use social media videos on my website?',
                      answer:
                        'Yes. The social media videos we create can be used both on the website and for different purposes. We are happy to help our partners to achieve their business goals.',
                    },
                  ]}
                />
              </div>
            </div>
          </div>

          {/*<div className="hidden md:block bg-gray-light py-23">*/}
          {/*        <div className="container">*/}
          {/*            <div className="flex flex-col justify-between w-full md:flex-row">*/}
          {/*                <div className="flex items-center">*/}
          {/*                    <p className="flex items-center font-black text-16 md:text-36 text-green mr-15">*/}
          {/*                        /!* {process.browser && window.innerWidth > 768 && <CountUp start={0} end={350} duration={2} suffix=" +" delay={1}></CountUp>} *!/*/}
          {/*                        350 +*/}
          {/*                    </p>*/}
          {/*                    <div className="flex items-center">*/}
          {/*                        <div>*/}
          {/*                            <div className="mr-10 border-t-10 border-b-10 border-l-12" style={{*/}
          {/*                                borderstyle: 'solid',*/}
          {/*                                borderColor: 'transparent transparent transparent #670F7A'*/}
          {/*                            }}/>*/}
          {/*                        </div>*/}
          {/*                        <p className="text-black">client SMM<br></br>Campaigns</p>*/}
          {/*                    </div>*/}
          {/*                </div>*/}
          {/*                <div className="flex items-center">*/}
          {/*                    <p className="flex items-center font-black text-16 md:text-36 text-green mr-15">*/}
          {/*                        /!* {<CountUp start={0} end={165200} duration={2} separator="," delay={1}></CountUp>} *!/*/}
          {/*                        165,200*/}
          {/*                    </p>*/}
          {/*                    <div className="flex items-center">*/}
          {/*                        <div>*/}
          {/*                            <div className="mr-10 border-t-10 border-b-10 border-l-12" style={{*/}
          {/*                                borderstyle: 'solid',*/}
          {/*                                borderColor: 'transparent transparent transparent #670F7A'*/}
          {/*                            }}/>*/}
          {/*                        </div>*/}
          {/*                        <p className="text-black">SM Posts<br></br>Created & Published</p>*/}
          {/*                    </div>*/}
          {/*                </div>*/}
          {/*                <div className="flex items-center">*/}
          {/*                    <p className="flex items-center font-black text-16 md:text-36 text-green mr-15">*/}
          {/*                        /!* {process.browser && window.innerWidth > 768 && <CountUp start={0} end={28} duration={3} suffix=" +" delay={1}></CountUp>} *!/*/}
          {/*                        28 +*/}
          {/*                    </p>*/}
          {/*                    <div className="flex items-center">*/}
          {/*                        <div>*/}
          {/*                            <div className="mr-10 border-t-10 border-b-10 border-l-12" style={{*/}
          {/*                                borderstyle: 'solid',*/}
          {/*                                borderColor: 'transparent transparent transparent #670F7A'*/}
          {/*                            }}/>*/}
          {/*                        </div>*/}
          {/*                        <p className="text-black">Social Media<br></br>Certified Experts</p>*/}
          {/*                    </div>*/}
          {/*                </div>*/}
          {/*            </div>*/}
          {/*        </div>*/}
          {/*    </div>*/}
          {/*    <div className="bg-white bg-grid ">*/}
          {/*    <div className="relative">*/}
          {/*        <div className="flex flex-col md:flex-row">*/}
          {/*            <div*/}
          {/*                className="relative w-full bg-fixed bg-center bg-cover fix-elem lg:w-40p bg-purple h-650 min-h-650"*/}
          {/*                style={{'backgroundImage': `url(https://weprodigi.com/uploads/images/smm/texture.png)`}}>*/}
          {/*                <div className={'absolute right-0 md:-right-150 bottom-0 z-50'}>*/}
          {/*                    <picture>*/}
          {/*                        <source media="(min-width:768px)" srcSet="/images/smm/Luso_smm.webp"*/}
          {/*                                type="image/webp"/>*/}
          {/*                        <source media="(min-width:768px)" srcSet="/images/smm/Luso_smm.png"*/}
          {/*                                type="image/png"/>*/}
          {/*                        <source media="(max-width:768px)" srcSet="https://weprodigi.com/uploads/images/smm/Luso_smm_mobile.png"*/}
          {/*                                type="image/png"/>*/}
          {/*                        <img width={this.props.width < 768 ? 256 : 307}*/}
          {/*                             height={this.props.width < 768 ? 236 : 482} src="" className='hide'*/}
          {/*                             alt={'personage  lusi'}/>*/}
          {/*                    </picture>*/}
          {/*                    <div className="absolute phone top-130 w-57 h-57 left-45"*/}
          {/*                         style={{'backgroundImage': `url(/images/smm/phone.svg)`}}>*/}
          {/*                        <div className="absolute w-8 h-8 vector1 top-20 left-30"*/}
          {/*                             style={{'backgroundImage': `url(/images/smm/vector1.png)`}}/>*/}
          {/*                        <div className="absolute vector2 w-14 h-14 top-12 left-32"*/}
          {/*                             style={{'backgroundImage': `url(/images/smm/vector2.png)`}}/>*/}
          {/*                        <div className="absolute top-0 w-20 h-20 vector3 left-36"*/}
          {/*                             style={{'backgroundImage': `url(/images/smm/vector3.png)`}}/>*/}
          {/*                         <style jsx global>{`*/}

          {/*                                 .jello-horizontal {*/}
          {/*                                      animation: slide1 1s ease-in-out infinite;*/}
          {/*                                     // margin-left: 9px;*/}
          {/*                                }*/}
          {/*                                  @keyframes slide1 {*/}
          {/*                                      0%,*/}
          {/*                                      100% {*/}
          {/*                                        transform: translate(0, 0);*/}
          {/*                                      }*/}
          {/*                                    */}
          {/*                                      50% {*/}
          {/*                                        transform: translate(10px, 0);*/}
          {/*                                      }*/}
          {/*                                    }*/}
          {/*                        .vector1{*/}
          {/*                            opacity:0;*/}
          {/*                              animation: vector  1s infinite;*/}
          {/*                              animation-delay:100ms;*/}
          {/*                        }*/}
          {/*                        .vector2{*/}
          {/*                            opacity:0;*/}
          {/*                             animation: vector  1s infinite;*/}
          {/*                             animation-delay:200ms;*/}
          {/*                        }*/}
          {/*                        .vector3{*/}
          {/*                            opacity:0;*/}
          {/*                             animation: vector  1s infinite;*/}
          {/*                             animation-delay: 400ms;*/}
          {/*                        }*/}
          {/*                       @keyframes vector {*/}
          {/*                          0% { opacity: 0.9 }*/}
          {/*                          5% { opactiy: 1 }*/}
          {/*                          6% { opactiy: 0.1 }*/}
          {/*                          100% { opactiy: 0.1; }*/}
          {/*                       }*/}
          {/*                       @media screen and (max-width:1440px){*/}
          {/*                            .text-part{*/}
          {/*                                padding-left:20px!important*/}
          {/*                            }*/}
          {/*                             .big-text-green {*/}
          {/*                                font-size:40px;*/}
          {/*                                line-height:40px*/}
          {/*                            }*/}
          {/*                            .fix-elem{*/}
          {/*                              height:550px!important;*/}
          {/*                              min-height:unset*/}
          {/*                            }*/}
          {/*                            .text-part{*/}
          {/*                              display:block;*/}
          {/*                              margin-top:40px*/}
          {/*                            }*/}
          {/*                       }*/}
          {/*                       @media screen and (max-width:780px){*/}
          {/*                            .lg:w-40p ,.lg:w-60p {*/}
          {/*                            width:100%*/}
          {/*                           }*/}
          {/*                           */}
          {/*                       }*/}
          {/*                    @media screen and (max-width:700px){*/}
          {/*                         .big-text-green {*/}
          {/*                                font-size:30px;*/}
          {/*                                line-height:30px*/}
          {/*                            }*/}
          {/*                            .small-text{*/}
          {/*                                font-size:18px;*/}
          {/*                                line-height:20px;*/}
          {/*                                width:200px;*/}
          {/*                                overflow: visible;*/}
          {/*                             }*/}
          {/*                            .phone{*/}
          {/*                              top:90px;*/}
          {/*                              left:33px*/}
          {/*                            }*/}
          {/*                             .fix-elem{*/}
          {/*                              height:350px!important;*/}
          {/*                              // min-height:unset*/}
          {/*                            }*/}
          {/*                            .text-part{*/}
          {/*                              margin-top:10px*/}
          {/*                            }*/}
          {/*                    }*/}
          {/*                  `}</style>*/}
          {/*                    </div>*/}
          {/*                </div>*/}
          {/*                <div*/}
          {/*                    className='absolute flex-col items-start justify-center block w-full h-full text-white text-part pl-15 sm:pl-20 md:pl-100 xl:pl-150 pb-200 md:flex'>*/}
          {/*                    <div*/}
          {/*                        className={'font-800 big-text-green text-green text-24 md:text-36 xl:text-72  uppercase leading-5 md:leading-88 pr-20 mt-20 md:mt-0 '}>Schedule*/}
          {/*                        a*/}
          {/*                        call*/}
          {/*                    </div>*/}
          {/*                    <div*/}
          {/*                        className={'font-normal small-text text-24 text-left leading-29 text-29 mt-15 pr-20'}>with*/}
          {/*                        our Account*/}
          {/*                    </div>*/}
          {/*                    <div*/}
          {/*                        className={'font-normal small-text text-24 text-left leading-29 text-29 mt-29 pr-20'}>Management*/}
          {/*                        Director*/}
          {/*                    </div>*/}
          {/*                </div>*/}
          {/*            </div>*/}
          {/*            <div className="flex items-center justify-center w-full lg:w-60p min-h-650 ">*/}
          {/*                <LazyLoad >*/}
          {/*                    <div*/}
          {/*                        className="m-auto calendly-inline-widget min-w-320 md:min-w-500 w-80p min-h-400 md:min-h-650 h-500 md:h-650"*/}
          {/*                        data-url="https://calendar.app.google/uJZkJfztLwHZcfkC7"*/}
          {/*                    >*/}
          {/*                        <iframe title={"calendly"}*/}
          {/*                                src="https://calendar.app.google/uJZkJfztLwHZcfkC7"*/}
          {/*                                frameBorder="0"*/}
          {/*                                width={this.props.width < 768 ? '100%' : '110%'}*/}
          {/*                                height={'100%'}*/}
          {/*                        />*/}
          {/*                    </div>*/}
          {/*                </LazyLoad>*/}
          {/*            </div>*/}
          {/*        </div>*/}
          {/*    </div>*/}
          {/*</div>*/}
          <SchedulaACall
            country={this.props.country}
            width={this.props.width}
            url="https://calendar.app.google/uJZkJfztLwHZcfkC7"
          />
        </LazyLoad>

        <CustomProposal
          country={this.props.country}
          show={this.state.showOfferModal}
          service={this.state.offerModalTitle}
          hide={this.hideOfferModal}
        />
        <Offer country={this.props.country} show={this.state.showOfferModal2} title="Social Media Marketing" hide={this.hideOfferModal2} />
        <SMMPricing
          from={'index'}
          id={'pricing'}
          country={this.props.country}
          show={this.state.showSMMPricingModal}
          title="Get SMM Pricing"
          hide={this.hideSMMPricingModal}
        />
        <SMMCustomProposal
          step={this.state.step}
          country={this.props.country}
          show={this.state.showSMMCustomProposalModal}
          title="Get SMM Pricing"
          hide={this.hideSMMCustomProposalModal}
          id={'smm'}
        />
        <CustomProposalWithoutPlatform
          step={this.state.step}
          country={this.props.country}
          platform={this.state.platform}
          show={this.state.showSMMCustomProposalWithoutPlatformModal}
          title="Get SMM Pricing"
          hide={this.hideSMMCustomProposalWithoutPlatformModal}
        />
      </div>
    );
  }
}
export default SocialMediaMarketing;
